
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models'
export type * from './prismaNamespace'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  User: 'User',
  Person: 'Person',
  EmailAlias: 'EmailAlias',
  PersonTypeAssignment: 'PersonTypeAssignment',
  RevenueDataManageGrant: 'RevenueDataManageGrant',
  PersonTypeMapping: 'PersonTypeMapping',
  ParticipantIdentity: 'ParticipantIdentity',
  PersonExternalIdentity: 'PersonExternalIdentity',
  PersonRedirect: 'PersonRedirect',
  PersonMatchCandidate: 'PersonMatchCandidate',
  CommitmentRecord: 'CommitmentRecord',
  CommitmentRecordView: 'CommitmentRecordView',
  CommitmentContest: 'CommitmentContest',
  CommitmentRecordEnablement: 'CommitmentRecordEnablement',
  EnrollmentAssociation: 'EnrollmentAssociation',
  GuardianAssociation: 'GuardianAssociation',
  PersonDataAccess: 'PersonDataAccess',
  ProgramParticipationAssociation: 'ProgramParticipationAssociation',
  SectionEnrollmentAssociation: 'SectionEnrollmentAssociation',
  MentorAssignment: 'MentorAssignment',
  Account: 'Account',
  Session: 'Session',
  VerificationToken: 'VerificationToken',
  McpToken: 'McpToken',
  OAuthAuthorizationCode: 'OAuthAuthorizationCode',
  OAuthAccessToken: 'OAuthAccessToken',
  UpdateCadence: 'UpdateCadence',
  Rock: 'Rock',
  RockScore: 'RockScore',
  Project: 'Project',
  RockProposalEdit: 'RockProposalEdit',
  Update: 'Update',
  Changelog: 'Changelog',
  ItemFollow: 'ItemFollow',
  Comment: 'Comment',
  Organization: 'Organization',
  OrgMembership: 'OrgMembership',
  OrgPersonProfile: 'OrgPersonProfile',
  ExperiencePreset: 'ExperiencePreset',
  OrgFeatureFlag: 'OrgFeatureFlag',
  SlackIntegration: 'SlackIntegration',
  SlackChannelDigestConfig: 'SlackChannelDigestConfig',
  SlackCitizenshipViolation: 'SlackCitizenshipViolation',
  SlackChannelBackfillJob: 'SlackChannelBackfillJob',
  HubSpotConnection: 'HubSpotConnection',
  GitHubAppInstallation: 'GitHubAppInstallation',
  NotionWorkspaceConnection: 'NotionWorkspaceConnection',
  RipplingConnection: 'RipplingConnection',
  IntegrationConnection: 'IntegrationConnection',
  IntegrationConnectionHealth: 'IntegrationConnectionHealth',
  PersonIntegrationConnection: 'PersonIntegrationConnection',
  HubSpotWebhookEvent: 'HubSpotWebhookEvent',
  Reply: 'Reply',
  Reaction: 'Reaction',
  MetricsDashboard: 'MetricsDashboard',
  DashboardItem: 'DashboardItem',
  DashboardItemHistory: 'DashboardItemHistory',
  DashboardItemLink: 'DashboardItemLink',
  REKSCriteria: 'REKSCriteria',
  WeeklyReflection: 'WeeklyReflection',
  PulseCheckReview: 'PulseCheckReview',
  PulseCheckShare: 'PulseCheckShare',
  PulseConversation: 'PulseConversation',
  PulseConversationMessage: 'PulseConversationMessage',
  PulseConversationAnnotation: 'PulseConversationAnnotation',
  PulsePersonalization: 'PulsePersonalization',
  PulseWorkItemPassLog: 'PulseWorkItemPassLog',
  PulseUserTypeAffinity: 'PulseUserTypeAffinity',
  PulseConversationMemory: 'PulseConversationMemory',
  AiBeliefCorrection: 'AiBeliefCorrection',
  SystemPrompt: 'SystemPrompt',
  ConfigVersion: 'ConfigVersion',
  AiModelOverride: 'AiModelOverride',
  EmailTemplate: 'EmailTemplate',
  PulseTeamSynthesis: 'PulseTeamSynthesis',
  PersonPulseSynthesis: 'PersonPulseSynthesis',
  PulseInsightsSummary: 'PulseInsightsSummary',
  AffectSignal: 'AffectSignal',
  PerformanceReview: 'PerformanceReview',
  ReviewDateArchive: 'ReviewDateArchive',
  PerformanceReviewValueRating: 'PerformanceReviewValueRating',
  PerformanceReviewValueException: 'PerformanceReviewValueException',
  DashboardItemReview: 'DashboardItemReview',
  DashboardReviewDraft: 'DashboardReviewDraft',
  DashboardReviewSession: 'DashboardReviewSession',
  Feedback: 'Feedback',
  FeedbackComment: 'FeedbackComment',
  FeedbackActivity: 'FeedbackActivity',
  FeedbackView: 'FeedbackView',
  FeedbackAnchor: 'FeedbackAnchor',
  FeedbackSession: 'FeedbackSession',
  REKSMeasurableLink: 'REKSMeasurableLink',
  AiAuditResponse: 'AiAuditResponse',
  PatternView: 'PatternView',
  PatternCache: 'PatternCache',
  KnowledgeGraphCache: 'KnowledgeGraphCache',
  PerformanceReviewSettings: 'PerformanceReviewSettings',
  PerformanceReviewPeriod: 'PerformanceReviewPeriod',
  TeamLeadAssignment: 'TeamLeadAssignment',
  SelfEvaluationWindow: 'SelfEvaluationWindow',
  SelfReflectionDraft: 'SelfReflectionDraft',
  FormDraft: 'FormDraft',
  QuarterlyPerformanceReview: 'QuarterlyPerformanceReview',
  QuarterlyReviewRecommendation: 'QuarterlyReviewRecommendation',
  QuarterlyReviewCheckIn: 'QuarterlyReviewCheckIn',
  QuarterlyReviewEditHistory: 'QuarterlyReviewEditHistory',
  QuarterlyReviewPeriod: 'QuarterlyReviewPeriod',
  EvaluationCadence: 'EvaluationCadence',
  ContractorCheckIn: 'ContractorCheckIn',
  PeerReviewNomination: 'PeerReviewNomination',
  ReviewSynthesis: 'ReviewSynthesis',
  Plan: 'Plan',
  PlanItem: 'PlanItem',
  PlanLabel: 'PlanLabel',
  PlanItemAcceptance: 'PlanItemAcceptance',
  PlanItemVersion: 'PlanItemVersion',
  PlanItemProposalEdit: 'PlanItemProposalEdit',
  IdeaHistory: 'IdeaHistory',
  EditSession: 'EditSession',
  Notification: 'Notification',
  NotificationDelivery: 'NotificationDelivery',
  NotificationPreference: 'NotificationPreference',
  NotificationDeliveryLog: 'NotificationDeliveryLog',
  PerformanceAlert: 'PerformanceAlert',
  ImpersonationLog: 'ImpersonationLog',
  Attachment: 'Attachment',
  LinkAttachment: 'LinkAttachment',
  TrainingItem: 'TrainingItem',
  TrainingPlan: 'TrainingPlan',
  TrainingPlanSection: 'TrainingPlanSection',
  TrainingPlanItem: 'TrainingPlanItem',
  TrainingAssignment: 'TrainingAssignment',
  TrainingItemProgress: 'TrainingItemProgress',
  Announcement: 'Announcement',
  AnnouncementRecipient: 'AnnouncementRecipient',
  ProfileQuestionnaire: 'ProfileQuestionnaire',
  PersonSensitiveData: 'PersonSensitiveData',
  RockDependency: 'RockDependency',
  PlanItemDependency: 'PlanItemDependency',
  ProjectDependency: 'ProjectDependency',
  PersonWidgetPreference: 'PersonWidgetPreference',
  CoachingTopic: 'CoachingTopic',
  CoachingPrepNote: 'CoachingPrepNote',
  FeatureFlag: 'FeatureFlag',
  FeatureFlagUserOverride: 'FeatureFlagUserOverride',
  FeatureFlagRoleOverride: 'FeatureFlagRoleOverride',
  AiChatConversation: 'AiChatConversation',
  AiChatMessage: 'AiChatMessage',
  AiChatMessageFeedback: 'AiChatMessageFeedback',
  UnmetNeed: 'UnmetNeed',
  UnmetNeedMonitor: 'UnmetNeedMonitor',
  AiChatResolvedEntity: 'AiChatResolvedEntity',
  FeatureRecommendation: 'FeatureRecommendation',
  MentionExchange: 'MentionExchange',
  Survey: 'Survey',
  SurveyShare: 'SurveyShare',
  SurveyQuestion: 'SurveyQuestion',
  SurveyRecipient: 'SurveyRecipient',
  SurveyResponse: 'SurveyResponse',
  SurveyAnswer: 'SurveyAnswer',
  SurveyInsightDismissal: 'SurveyInsightDismissal',
  SurveyResponseComment: 'SurveyResponseComment',
  SurveyTemplate: 'SurveyTemplate',
  QuestionBankItem: 'QuestionBankItem',
  SurveySequence: 'SurveySequence',
  SurveySequenceStep: 'SurveySequenceStep',
  SurveySequenceEnrollment: 'SurveySequenceEnrollment',
  SurveySequenceStepExecution: 'SurveySequenceStepExecution',
  PulsePromptCustomization: 'PulsePromptCustomization',
  CheckInPromptCustomization: 'CheckInPromptCustomization',
  QuarterReview: 'QuarterReview',
  RockReview: 'RockReview',
  PulseReminderConfig: 'PulseReminderConfig',
  PulseReminderSchedule: 'PulseReminderSchedule',
  PulseReminderIncludedUnit: 'PulseReminderIncludedUnit',
  Event: 'Event',
  JobFamily: 'JobFamily',
  JobFamilySpecialization: 'JobFamilySpecialization',
  LevelTrack: 'LevelTrack',
  LevelDimension: 'LevelDimension',
  LevelDefinition: 'LevelDefinition',
  LevelTitle: 'LevelTitle',
  LevelDimensionDescription: 'LevelDimensionDescription',
  CalibrationCycle: 'CalibrationCycle',
  CalibrationParticipantGrant: 'CalibrationParticipantGrant',
  CalibrationNote: 'CalibrationNote',
  LevelProposal: 'LevelProposal',
  BonusPeriod: 'BonusPeriod',
  BonusRecord: 'BonusRecord',
  TodayBrief: 'TodayBrief',
  CronJobRun: 'CronJobRun',
  PlatformAuditLog: 'PlatformAuditLog',
  FieldProvenance: 'FieldProvenance',
  SyncEvent: 'SyncEvent',
  SyncEventDailySummary: 'SyncEventDailySummary',
  PipRequest: 'PipRequest',
  Pip: 'Pip',
  PipMeasurable: 'PipMeasurable',
  PipWeeklyReview: 'PipWeeklyReview',
  PipSignature: 'PipSignature',
  PipActivity: 'PipActivity',
  Certification: 'Certification',
  AttendanceRecord: 'AttendanceRecord',
  Assessment: 'Assessment',
  AssessmentSection: 'AssessmentSection',
  AssessmentItem: 'AssessmentItem',
  AssessmentResponse: 'AssessmentResponse',
  AssessmentAccommodation: 'AssessmentAccommodation',
  MeetingOccurrence: 'MeetingOccurrence',
  MeetingAttendee: 'MeetingAttendee',
  MeetingShare: 'MeetingShare',
  MeetingAgenda: 'MeetingAgenda',
  MeetingAgendaSection: 'MeetingAgendaSection',
  MeetingSection: 'MeetingSection',
  MeetingPrivateNote: 'MeetingPrivateNote',
  MeetingSummary: 'MeetingSummary',
  ObservationCycleNote: 'ObservationCycleNote',
  KynetaMeta: 'KynetaMeta',
  KynetaRecord: 'KynetaRecord',
  KynetaStoreMeta: 'KynetaStoreMeta',
  DisciplineIncident: 'DisciplineIncident',
  StudentDisciplineIncidentAssociation: 'StudentDisciplineIncidentAssociation',
  DisciplineAction: 'DisciplineAction',
  BehaviorIncident: 'BehaviorIncident',
  StudentDemographic: 'StudentDemographic',
  StudentRace: 'StudentRace',
  AcademicTerm: 'AcademicTerm',
  LinearWorkspaceConnection: 'LinearWorkspaceConnection',
  GoogleCalendarConnection: 'GoogleCalendarConnection',
  GoogleGmailConnection: 'GoogleGmailConnection',
  SchoolCalendar: 'SchoolCalendar',
  SchoolCalendarDate: 'SchoolCalendarDate',
  Course: 'Course',
  CourseSection: 'CourseSection',
  SectionRoster: 'SectionRoster',
  StudentAcademicRecordGrade: 'StudentAcademicRecordGrade',
  CalendarEvent: 'CalendarEvent',
  CalendarEventAttendee: 'CalendarEventAttendee',
  CalendarEventContribution: 'CalendarEventContribution',
  CalendarSyncState: 'CalendarSyncState',
  CalendarWatchChannel: 'CalendarWatchChannel',
  CalendarSelection: 'CalendarSelection',
  Board: 'Board',
  BoardWidget: 'BoardWidget',
  BoardColumn: 'BoardColumn',
  TagGroup: 'TagGroup',
  Tag: 'Tag',
  PulseConversationDraftItem: 'PulseConversationDraftItem',
  TagAssignment: 'TagAssignment',
  Priority: 'Priority',
  ValueProfile: 'ValueProfile',
  PracticeProfile: 'PracticeProfile',
  MeasureProfile: 'MeasureProfile',
  MeasureReading: 'MeasureReading',
  Governs: 'Governs',
  Indicates: 'Indicates',
  OutcomeTarget: 'OutcomeTarget',
  Watches: 'Watches',
  Reviews: 'Reviews',
  AgendaItem: 'AgendaItem',
  AgendaVote: 'AgendaVote',
  RatingRound: 'RatingRound',
  RatingRoundItem: 'RatingRoundItem',
  RatingRoundRater: 'RatingRoundRater',
  RatingSubmission: 'RatingSubmission',
  BeliefAuthor: 'BeliefAuthor',
  RollupSchedule: 'RollupSchedule',
  ExampleContentApplication: 'ExampleContentApplication',
  SavedView: 'SavedView',
  ViewItemOrder: 'ViewItemOrder',
  PulseRequest: 'PulseRequest',
  PulseRequestLayer: 'PulseRequestLayer',
  PulseRequestSend: 'PulseRequestSend',
  PulseRequestSendRollup: 'PulseRequestSendRollup',
  PulseRequestRecipient: 'PulseRequestRecipient',
  PracticeRecord: 'PracticeRecord',
  PracticeRecordRevision: 'PracticeRecordRevision',
  PracticeRecordSignature: 'PracticeRecordSignature',
  PracticeRunSynthesis: 'PracticeRunSynthesis',
  PracticeAssignment: 'PracticeAssignment',
  Evidence: 'Evidence',
  EvidenceCitation: 'EvidenceCitation',
  Belief: 'Belief',
  Pulse: 'Pulse',
  PrioritySupport: 'PrioritySupport',
  BeliefEvidence: 'BeliefEvidence',
  GraphConsolidationRun: 'GraphConsolidationRun',
  EvidenceClassificationChange: 'EvidenceClassificationChange',
  OrgClassificationDefault: 'OrgClassificationDefault',
  OrgClassificationDefaultChange: 'OrgClassificationDefaultChange',
  GraphConsolidationChange: 'GraphConsolidationChange',
  BeliefClaimEdge: 'BeliefClaimEdge',
  BeliefResolution: 'BeliefResolution',
  BeliefLink: 'BeliefLink',
  PulseParticipant: 'PulseParticipant',
  PriorityOrgUnit: 'PriorityOrgUnit',
  PersonRelationship: 'PersonRelationship',
  SimulationRun: 'SimulationRun',
  SimulationPeriod: 'SimulationPeriod',
  PriorityPlanMembership: 'PriorityPlanMembership',
  PriorityAssignment: 'PriorityAssignment',
  PriorityExtractedItem: 'PriorityExtractedItem',
  PriorityEvidence: 'PriorityEvidence',
  LegacyBridge: 'LegacyBridge',
  LegacyEntityRedirect: 'LegacyEntityRedirect',
  PriorityDependency: 'PriorityDependency',
  PriorityScore: 'PriorityScore',
  ContextResearchRun: 'ContextResearchRun',
  ContextResearchSection: 'ContextResearchSection',
  RosterCandidate: 'RosterCandidate',
  StrategicPlan: 'StrategicPlan',
  StrategicPlanCandidate: 'StrategicPlanCandidate',
  StrategicPlanNodeEdit: 'StrategicPlanNodeEdit',
  ContextSource: 'ContextSource',
  ContextSourceChunk: 'ContextSourceChunk',
  WelcomeLeader: 'WelcomeLeader',
  ConversationArtifact: 'ConversationArtifact',
  ActionBoardIntervention: 'ActionBoardIntervention',
  TodayFocusSteeringSignal: 'TodayFocusSteeringSignal',
  TodayFocusProfileSuppression: 'TodayFocusProfileSuppression',
  SaiWeeklyRollup: 'SaiWeeklyRollup',
  SaiBreadthCell: 'SaiBreadthCell',
  SaiSignalRollup: 'SaiSignalRollup',
  SaiAlertRollup: 'SaiAlertRollup',
  SaiEducatorCohortRollup: 'SaiEducatorCohortRollup',
  SaiReportImport: 'SaiReportImport',
  SaiOrgMetric: 'SaiOrgMetric',
  SaiSchoolMetric: 'SaiSchoolMetric',
  SaiTeacherMetric: 'SaiTeacherMetric',
  SaiCatalogUsage: 'SaiCatalogUsage',
  OrgUnit: 'OrgUnit',
  SchoolProfile: 'SchoolProfile',
  UnitAssignment: 'UnitAssignment',
  ReportsTo: 'ReportsTo',
  Note: 'Note',
  Recording: 'Recording',
  RecordingChunk: 'RecordingChunk',
  LiveSummarySnapshot: 'LiveSummarySnapshot',
  LiveExtractionWindow: 'LiveExtractionWindow',
  NoteOutputFlag: 'NoteOutputFlag',
  NoteSummaryRevision: 'NoteSummaryRevision',
  NoteThreadGist: 'NoteThreadGist',
  NoteSearchChunk: 'NoteSearchChunk',
  NoteSearchDirty: 'NoteSearchDirty',
  NoteShare: 'NoteShare',
  NoteSubject: 'NoteSubject',
  NoteRollupInput: 'NoteRollupInput',
  NoteChatSource: 'NoteChatSource',
  TranscriptSegment: 'TranscriptSegment',
  TranscriptVersion: 'TranscriptVersion',
  TranscriptVersionWindow: 'TranscriptVersionWindow',
  ExtractedItem: 'ExtractedItem',
  TranscriptionJob: 'TranscriptionJob',
  OutputTemplate: 'OutputTemplate',
  OutputTemplateVersion: 'OutputTemplateVersion',
  TemplateResponse: 'TemplateResponse',
  OutputTemplateAttachment: 'OutputTemplateAttachment',
  OrgAiProfile: 'OrgAiProfile',
  OrgAiProfileRevision: 'OrgAiProfileRevision'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  emailVerified: 'emailVerified',
  name: 'name',
  image: 'image',
  personId: 'personId',
  themePreference: 'themePreference',
  hideTrainingHints: 'hideTrainingHints',
  timezone: 'timezone',
  timezoneMode: 'timezoneMode',
  platformRole: 'platformRole',
  lastActiveOrgId: 'lastActiveOrgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSeenAt: 'lastSeenAt',
  lastSignInAt: 'lastSignInAt'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const PersonScalarFieldEnum = {
  id: 'id',
  name: 'name',
  preferredName: 'preferredName',
  email: 'email',
  image: 'image',
  photoMetadata: 'photoMetadata',
  title: 'title',
  level: 'level',
  isActive: 'isActive',
  isContractor: 'isContractor',
  calendarSynopsisOptedOut: 'calendarSynopsisOptedOut',
  calendarSynopsisPreference: 'calendarSynopsisPreference',
  hubspotSynopsisPreference: 'hubspotSynopsisPreference',
  githubSynopsisPreference: 'githubSynopsisPreference',
  slackSynopsisPreference: 'slackSynopsisPreference',
  linearSynopsisPreference: 'linearSynopsisPreference',
  notionSynopsisPreference: 'notionSynopsisPreference',
  emailSynopsisPreference: 'emailSynopsisPreference',
  granolaSynopsisPreference: 'granolaSynopsisPreference',
  terminatedAt: 'terminatedAt',
  terminationNote: 'terminationNote',
  managerId: 'managerId',
  jobFamilyId: 'jobFamilyId',
  jobFamilySpecializationId: 'jobFamilySpecializationId',
  canManageRevenueData: 'canManageRevenueData',
  startDate: 'startDate',
  birthdayMonth: 'birthdayMonth',
  birthdayDay: 'birthdayDay',
  showBirthday: 'showBirthday',
  employeeNumber: 'employeeNumber',
  isAgent: 'isAgent',
  orgId: 'orgId',
  isDemoSwitchable: 'isDemoSwitchable',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hideTrainingHints: 'hideTrainingHints'
} as const

export type PersonScalarFieldEnum = (typeof PersonScalarFieldEnum)[keyof typeof PersonScalarFieldEnum]


export const EmailAliasScalarFieldEnum = {
  id: 'id',
  email: 'email',
  personId: 'personId',
  source: 'source',
  createdAt: 'createdAt'
} as const

export type EmailAliasScalarFieldEnum = (typeof EmailAliasScalarFieldEnum)[keyof typeof EmailAliasScalarFieldEnum]


export const PersonTypeAssignmentScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  orgId: 'orgId',
  type: 'type',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  grantedById: 'grantedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonTypeAssignmentScalarFieldEnum = (typeof PersonTypeAssignmentScalarFieldEnum)[keyof typeof PersonTypeAssignmentScalarFieldEnum]


export const RevenueDataManageGrantScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  orgId: 'orgId',
  featureKey: 'featureKey',
  grantedById: 'grantedById',
  grantedAt: 'grantedAt',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RevenueDataManageGrantScalarFieldEnum = (typeof RevenueDataManageGrantScalarFieldEnum)[keyof typeof RevenueDataManageGrantScalarFieldEnum]


export const PersonTypeMappingScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sourceSystem: 'sourceSystem',
  externalType: 'externalType',
  cadenceType: 'cadenceType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonTypeMappingScalarFieldEnum = (typeof PersonTypeMappingScalarFieldEnum)[keyof typeof PersonTypeMappingScalarFieldEnum]


export const ParticipantIdentityScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  email: 'email',
  displayName: 'displayName',
  avatarUrl: 'avatarUrl',
  accessContext: 'accessContext',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type ParticipantIdentityScalarFieldEnum = (typeof ParticipantIdentityScalarFieldEnum)[keyof typeof ParticipantIdentityScalarFieldEnum]


export const PersonExternalIdentityScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  system: 'system',
  externalId: 'externalId',
  idType: 'idType',
  source: 'source',
  lastVerifiedAt: 'lastVerifiedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonExternalIdentityScalarFieldEnum = (typeof PersonExternalIdentityScalarFieldEnum)[keyof typeof PersonExternalIdentityScalarFieldEnum]


export const PersonRedirectScalarFieldEnum = {
  id: 'id',
  fromPersonId: 'fromPersonId',
  toPersonId: 'toPersonId',
  orgId: 'orgId',
  approvedById: 'approvedById',
  signals: 'signals',
  movedRows: 'movedRows',
  createdAt: 'createdAt',
  revertedAt: 'revertedAt',
  revertedById: 'revertedById'
} as const

export type PersonRedirectScalarFieldEnum = (typeof PersonRedirectScalarFieldEnum)[keyof typeof PersonRedirectScalarFieldEnum]


export const PersonMatchCandidateScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personAId: 'personAId',
  personBId: 'personBId',
  status: 'status',
  score: 'score',
  signals: 'signals',
  decidedById: 'decidedById',
  decidedAt: 'decidedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonMatchCandidateScalarFieldEnum = (typeof PersonMatchCandidateScalarFieldEnum)[keyof typeof PersonMatchCandidateScalarFieldEnum]


export const CommitmentRecordScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  stream: 'stream',
  keptCount: 'keptCount',
  notKeptCount: 'notKeptCount',
  excludedCount: 'excludedCount',
  rate: 'rate',
  intervalLow: 'intervalLow',
  intervalHigh: 'intervalHigh',
  orgNorm: 'orgNorm',
  band: 'band',
  trend: 'trend',
  windowStart: 'windowStart',
  computedAt: 'computedAt'
} as const

export type CommitmentRecordScalarFieldEnum = (typeof CommitmentRecordScalarFieldEnum)[keyof typeof CommitmentRecordScalarFieldEnum]


export const CommitmentRecordViewScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  viewerPersonId: 'viewerPersonId',
  subjectPersonId: 'subjectPersonId',
  viewedAt: 'viewedAt'
} as const

export type CommitmentRecordViewScalarFieldEnum = (typeof CommitmentRecordViewScalarFieldEnum)[keyof typeof CommitmentRecordViewScalarFieldEnum]


export const CommitmentContestScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  subjectPersonId: 'subjectPersonId',
  itemKind: 'itemKind',
  itemId: 'itemId',
  note: 'note',
  createdAt: 'createdAt'
} as const

export type CommitmentContestScalarFieldEnum = (typeof CommitmentContestScalarFieldEnum)[keyof typeof CommitmentContestScalarFieldEnum]


export const CommitmentRecordEnablementScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  enabledById: 'enabledById',
  enabledAt: 'enabledAt',
  attestations: 'attestations',
  disabledAt: 'disabledAt',
  disabledById: 'disabledById'
} as const

export type CommitmentRecordEnablementScalarFieldEnum = (typeof CommitmentRecordEnablementScalarFieldEnum)[keyof typeof CommitmentRecordEnablementScalarFieldEnum]


export const EnrollmentAssociationScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  orgId: 'orgId',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  entryTypeCode: 'entryTypeCode',
  exitTypeCode: 'exitTypeCode',
  gradeLevel: 'gradeLevel',
  homeroom: 'homeroom',
  unitId: 'unitId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EnrollmentAssociationScalarFieldEnum = (typeof EnrollmentAssociationScalarFieldEnum)[keyof typeof EnrollmentAssociationScalarFieldEnum]


export const GuardianAssociationScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  dependentPersonId: 'dependentPersonId',
  orgId: 'orgId',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  relationshipType: 'relationshipType',
  contactPriority: 'contactPriority',
  isEmergencyContact: 'isEmergencyContact',
  hasLegalCustody: 'hasLegalCustody',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GuardianAssociationScalarFieldEnum = (typeof GuardianAssociationScalarFieldEnum)[keyof typeof GuardianAssociationScalarFieldEnum]


export const PersonDataAccessScalarFieldEnum = {
  id: 'id',
  viewerPersonId: 'viewerPersonId',
  subjectPersonId: 'subjectPersonId',
  scope: 'scope',
  grantedById: 'grantedById',
  grantedAt: 'grantedAt',
  effectiveFrom: 'effectiveFrom',
  effectiveUntil: 'effectiveUntil',
  revokedAt: 'revokedAt',
  revokedById: 'revokedById',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonDataAccessScalarFieldEnum = (typeof PersonDataAccessScalarFieldEnum)[keyof typeof PersonDataAccessScalarFieldEnum]


export const ProgramParticipationAssociationScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  programId: 'programId',
  orgId: 'orgId',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  participationType: 'participationType',
  exitReason: 'exitReason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ProgramParticipationAssociationScalarFieldEnum = (typeof ProgramParticipationAssociationScalarFieldEnum)[keyof typeof ProgramParticipationAssociationScalarFieldEnum]


export const SectionEnrollmentAssociationScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  sectionId: 'sectionId',
  orgId: 'orgId',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  gradingPeriod: 'gradingPeriod',
  attendanceStatus: 'attendanceStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SectionEnrollmentAssociationScalarFieldEnum = (typeof SectionEnrollmentAssociationScalarFieldEnum)[keyof typeof SectionEnrollmentAssociationScalarFieldEnum]


export const MentorAssignmentScalarFieldEnum = {
  id: 'id',
  mentorPersonId: 'mentorPersonId',
  menteePersonId: 'menteePersonId',
  orgId: 'orgId',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  assignmentType: 'assignmentType',
  reviewCycleId: 'reviewCycleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MentorAssignmentScalarFieldEnum = (typeof MentorAssignmentScalarFieldEnum)[keyof typeof MentorAssignmentScalarFieldEnum]


export const AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires',
  createdAt: 'createdAt'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
} as const

export type VerificationTokenScalarFieldEnum = (typeof VerificationTokenScalarFieldEnum)[keyof typeof VerificationTokenScalarFieldEnum]


export const McpTokenScalarFieldEnum = {
  id: 'id',
  name: 'name',
  tokenHash: 'tokenHash',
  personId: 'personId',
  lastUsed: 'lastUsed',
  expiresAt: 'expiresAt',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type McpTokenScalarFieldEnum = (typeof McpTokenScalarFieldEnum)[keyof typeof McpTokenScalarFieldEnum]


export const OAuthAuthorizationCodeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  redirectUri: 'redirectUri',
  scope: 'scope',
  clientId: 'clientId',
  personId: 'personId',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type OAuthAuthorizationCodeScalarFieldEnum = (typeof OAuthAuthorizationCodeScalarFieldEnum)[keyof typeof OAuthAuthorizationCodeScalarFieldEnum]


export const OAuthAccessTokenScalarFieldEnum = {
  id: 'id',
  tokenHash: 'tokenHash',
  refreshTokenHash: 'refreshTokenHash',
  scope: 'scope',
  clientId: 'clientId',
  personId: 'personId',
  expiresAt: 'expiresAt',
  refreshExpiresAt: 'refreshExpiresAt',
  lastUsed: 'lastUsed',
  revokedAt: 'revokedAt',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type OAuthAccessTokenScalarFieldEnum = (typeof OAuthAccessTokenScalarFieldEnum)[keyof typeof OAuthAccessTokenScalarFieldEnum]


export const UpdateCadenceScalarFieldEnum = {
  id: 'id',
  itemType: 'itemType',
  frequencyDays: 'frequencyDays',
  enableProactiveNotify: 'enableProactiveNotify',
  proactiveNotifyDaysBefore: 'proactiveNotifyDaysBefore',
  enableAutoTransition: 'enableAutoTransition',
  notificationMessage: 'notificationMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type UpdateCadenceScalarFieldEnum = (typeof UpdateCadenceScalarFieldEnum)[keyof typeof UpdateCadenceScalarFieldEnum]


export const RockScalarFieldEnum = {
  id: 'id',
  title: 'title',
  charter: 'charter',
  rationale: 'rationale',
  status: 'status',
  state: 'state',
  startDate: 'startDate',
  targetDate: 'targetDate',
  manualOrder: 'manualOrder',
  alignment: 'alignment',
  aifeImpact: 'aifeImpact',
  effort: 'effort',
  tier: 'tier',
  leverageMultiplier: 'leverageMultiplier',
  captainId: 'captainId',
  createdById: 'createdById',
  trackCost: 'trackCost',
  targetCost: 'targetCost',
  videoUrl: 'videoUrl',
  parentId: 'parentId',
  teamId: 'teamId',
  percentComplete: 'percentComplete',
  associatedGroupId: 'associatedGroupId',
  latestUpdateId: 'latestUpdateId',
  latestUpdateAt: 'latestUpdateAt',
  lastUpdateReminderSentAt: 'lastUpdateReminderSentAt',
  nextUpdateDueAt: 'nextUpdateDueAt',
  completedAt: 'completedAt',
  cancelledAt: 'cancelledAt',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  embeddingModel: 'embeddingModel',
  embeddedAt: 'embeddedAt',
  embeddingVersion: 'embeddingVersion',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isPrivate: 'isPrivate',
  proposedById: 'proposedById',
  proposalState: 'proposalState',
  lastModifiedRole: 'lastModifiedRole',
  proposalTimestamp: 'proposalTimestamp',
  taskDefaultAssigneeType: 'taskDefaultAssigneeType',
  taskDefaultAssigneeId: 'taskDefaultAssigneeId',
  taskDefaultDueDateOffset: 'taskDefaultDueDateOffset',
  viewingAsUserId: 'viewingAsUserId',
  fulfillmentScore: 'fulfillmentScore',
  fulfillmentRationale: 'fulfillmentRationale',
  fulfillmentComputedAt: 'fulfillmentComputedAt'
} as const

export type RockScalarFieldEnum = (typeof RockScalarFieldEnum)[keyof typeof RockScalarFieldEnum]


export const RockScoreScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  rockId: 'rockId',
  leverageScore: 'leverageScore',
  formulaVersion: 'formulaVersion',
  scorer: 'scorer',
  scoredAt: 'scoredAt',
  isOverridden: 'isOverridden',
  overrideJustification: 'overrideJustification',
  rationale: 'rationale',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RockScoreScalarFieldEnum = (typeof RockScoreScalarFieldEnum)[keyof typeof RockScoreScalarFieldEnum]


export const ProjectScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  status: 'status',
  state: 'state',
  startDate: 'startDate',
  targetDate: 'targetDate',
  manualOrder: 'manualOrder',
  percentComplete: 'percentComplete',
  captainId: 'captainId',
  createdById: 'createdById',
  viewingAsUserId: 'viewingAsUserId',
  trackCost: 'trackCost',
  targetCost: 'targetCost',
  videoUrl: 'videoUrl',
  parentRockId: 'parentRockId',
  parentProjectId: 'parentProjectId',
  teamId: 'teamId',
  associatedGroupId: 'associatedGroupId',
  latestUpdateId: 'latestUpdateId',
  latestUpdateAt: 'latestUpdateAt',
  lastUpdateReminderSentAt: 'lastUpdateReminderSentAt',
  nextUpdateDueAt: 'nextUpdateDueAt',
  completedAt: 'completedAt',
  cancelledAt: 'cancelledAt',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  embeddingModel: 'embeddingModel',
  embeddedAt: 'embeddedAt',
  embeddingVersion: 'embeddingVersion',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isPrivate: 'isPrivate',
  taskDefaultAssigneeType: 'taskDefaultAssigneeType',
  taskDefaultAssigneeId: 'taskDefaultAssigneeId',
  taskDefaultDueDateOffset: 'taskDefaultDueDateOffset'
} as const

export type ProjectScalarFieldEnum = (typeof ProjectScalarFieldEnum)[keyof typeof ProjectScalarFieldEnum]


export const RockProposalEditScalarFieldEnum = {
  id: 'id',
  rockId: 'rockId',
  proposedById: 'proposedById',
  editorRole: 'editorRole',
  originalValues: 'originalValues',
  changedFields: 'changedFields',
  proposalState: 'proposalState',
  resolvedAt: 'resolvedAt',
  resolvedById: 'resolvedById',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type RockProposalEditScalarFieldEnum = (typeof RockProposalEditScalarFieldEnum)[keyof typeof RockProposalEditScalarFieldEnum]


export const UpdateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorId: 'authorId',
  rockId: 'rockId',
  projectId: 'projectId',
  priorityId: 'priorityId',
  status: 'status',
  progress: 'progress',
  nextSteps: 'nextSteps',
  helpNeeded: 'helpNeeded',
  hillChartPosition: 'hillChartPosition',
  currentCost: 'currentCost',
  percentComplete: 'percentComplete',
  percentCompleteChanged: 'percentCompleteChanged',
  state: 'state',
  stateChanged: 'stateChanged',
  statusChanged: 'statusChanged',
  progressChanged: 'progressChanged',
  nextStepsChanged: 'nextStepsChanged',
  helpNeededChanged: 'helpNeededChanged',
  hillChartPositionChanged: 'hillChartPositionChanged',
  currentCostChanged: 'currentCostChanged',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  submissionId: 'submissionId',
  viewingAsUserId: 'viewingAsUserId',
  beliefId: 'beliefId'
} as const

export type UpdateScalarFieldEnum = (typeof UpdateScalarFieldEnum)[keyof typeof UpdateScalarFieldEnum]


export const ChangelogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  authorId: 'authorId',
  entityType: 'entityType',
  entityId: 'entityId',
  action: 'action',
  field: 'field',
  oldValue: 'oldValue',
  newValue: 'newValue',
  oldParentId: 'oldParentId',
  newParentId: 'newParentId',
  orgId: 'orgId'
} as const

export type ChangelogScalarFieldEnum = (typeof ChangelogScalarFieldEnum)[keyof typeof ChangelogScalarFieldEnum]


export const ItemFollowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  rockId: 'rockId',
  projectId: 'projectId',
  orgId: 'orgId'
} as const

export type ItemFollowScalarFieldEnum = (typeof ItemFollowScalarFieldEnum)[keyof typeof ItemFollowScalarFieldEnum]


export const CommentScalarFieldEnum = {
  id: 'id',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entityType: 'entityType',
  entityId: 'entityId',
  authorId: 'authorId',
  rockId: 'rockId',
  projectId: 'projectId',
  measurableId: 'measurableId',
  planItemId: 'planItemId',
  planId: 'planId',
  reflectionId: 'reflectionId',
  performanceReviewId: 'performanceReviewId',
  meetingOccurrenceId: 'meetingOccurrenceId',
  meetingSection: 'meetingSection',
  meetingHighlightId: 'meetingHighlightId',
  evidenceId: 'evidenceId',
  meetingSectionId: 'meetingSectionId',
  priorityId: 'priorityId',
  beliefId: 'beliefId',
  agendaItemId: 'agendaItemId',
  origin: 'origin',
  graphExtractedAt: 'graphExtractedAt',
  graphExtractionAttempts: 'graphExtractionAttempts',
  graphExtractionAttemptedAt: 'graphExtractionAttemptedAt',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  isConcern: 'isConcern',
  isQuestion: 'isQuestion',
  aiAnswer: 'aiAnswer',
  viewingAsUserId: 'viewingAsUserId',
  anchorQuote: 'anchorQuote',
  anchorPrefix: 'anchorPrefix',
  anchorSuffix: 'anchorSuffix',
  anchorStart: 'anchorStart',
  anchorEnd: 'anchorEnd',
  anchorBlockId: 'anchorBlockId'
} as const

export type CommentScalarFieldEnum = (typeof CommentScalarFieldEnum)[keyof typeof CommentScalarFieldEnum]


export const OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  type: 'type',
  scenario: 'scenario',
  expiresAt: 'expiresAt',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isSimulation: 'isSimulation',
  parentOrgId: 'parentOrgId',
  orgKind: 'orgKind',
  externalIds: 'externalIds',
  sector: 'sector',
  websiteUrl: 'websiteUrl',
  description: 'description',
  terminology: 'terminology',
  statusLabels: 'statusLabels',
  ratingsAudience: 'ratingsAudience',
  waysOfWorkingTitle: 'waysOfWorkingTitle',
  showPurpose: 'showPurpose',
  showVision: 'showVision',
  showMission: 'showMission',
  showCoreValues: 'showCoreValues',
  showScorecard: 'showScorecard',
  showDashboards: 'showDashboards',
  defaultCollapsed: 'defaultCollapsed',
  componentOrder: 'componentOrder',
  presentationModeOverrides: 'presentationModeOverrides',
  reksResultsWeight: 'reksResultsWeight',
  reksEffortWeight: 'reksEffortWeight',
  reksKnowledgeWeight: 'reksKnowledgeWeight',
  reksSkillsWeight: 'reksSkillsWeight',
  reksValuesWeight: 'reksValuesWeight',
  targetAtRiskTolerance: 'targetAtRiskTolerance',
  practiceRecordSharing: 'practiceRecordSharing',
  practiceVisibilityDefault: 'practiceVisibilityDefault',
  boardModuleEnabled: 'boardModuleEnabled',
  boardMeetingCadence: 'boardMeetingCadence',
  boardNextMeetingDate: 'boardNextMeetingDate',
  calendarSynopsisEnabled: 'calendarSynopsisEnabled',
  calendarSynopsisMode: 'calendarSynopsisMode',
  hubspotSynopsisMode: 'hubspotSynopsisMode',
  githubSynopsisMode: 'githubSynopsisMode',
  slackSynopsisMode: 'slackSynopsisMode',
  linearSynopsisMode: 'linearSynopsisMode',
  notionSynopsisMode: 'notionSynopsisMode',
  emailSynopsisMode: 'emailSynopsisMode',
  granolaSynopsisMode: 'granolaSynopsisMode',
  granolaPersonalConnections: 'granolaPersonalConnections',
  calendarPersonalConnections: 'calendarPersonalConnections',
  aiChatEnabled: 'aiChatEnabled',
  aiPulseSynthesisEnabled: 'aiPulseSynthesisEnabled',
  todayBriefEnabled: 'todayBriefEnabled',
  aiWidgetsEnabled: 'aiWidgetsEnabled',
  notetakerEnabled: 'notetakerEnabled',
  pulseAutoExtractOnSubmit: 'pulseAutoExtractOnSubmit',
  customMeetingsEnabled: 'customMeetingsEnabled',
  navLeftItems: 'navLeftItems',
  navRightItems: 'navRightItems',
  landingPath: 'landingPath',
  userMenuSections: 'userMenuSections',
  experiencePresetId: 'experiencePresetId',
  experiencePresetAppliedAt: 'experiencePresetAppliedAt',
  autoCreateMeasurables: 'autoCreateMeasurables',
  monthlyCheckInsEnabled: 'monthlyCheckInsEnabled',
  selfEvaluationsEnabled: 'selfEvaluationsEnabled',
  emailNotificationsEnabled: 'emailNotificationsEnabled',
  slackNotificationsEnabled: 'slackNotificationsEnabled',
  notificationChannelDefaults: 'notificationChannelDefaults',
  timezone: 'timezone',
  pulseWeekRolloverDay: 'pulseWeekRolloverDay',
  recordingRetentionDays: 'recordingRetentionDays',
  businessHoursStart: 'businessHoursStart',
  businessHoursEnd: 'businessHoursEnd',
  pipEndReminderDaysWindow: 'pipEndReminderDaysWindow',
  pipNotifiedAdminIds: 'pipNotifiedAdminIds',
  seedVersion: 'seedVersion',
  workspaceDomain: 'workspaceDomain'
} as const

export type OrganizationScalarFieldEnum = (typeof OrganizationScalarFieldEnum)[keyof typeof OrganizationScalarFieldEnum]


export const OrgMembershipScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  orgId: 'orgId',
  role: 'role',
  status: 'status',
  joinedAt: 'joinedAt'
} as const

export type OrgMembershipScalarFieldEnum = (typeof OrgMembershipScalarFieldEnum)[keyof typeof OrgMembershipScalarFieldEnum]


export const OrgPersonProfileScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  orgId: 'orgId',
  title: 'title',
  level: 'level',
  managerId: 'managerId',
  jobFamilyId: 'jobFamilyId',
  jobFamilySpecializationId: 'jobFamilySpecializationId',
  isActive: 'isActive',
  isContractor: 'isContractor',
  terminatedAt: 'terminatedAt',
  terminationNote: 'terminationNote',
  startDate: 'startDate',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrgPersonProfileScalarFieldEnum = (typeof OrgPersonProfileScalarFieldEnum)[keyof typeof OrgPersonProfileScalarFieldEnum]


export const ExperiencePresetScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  flags: 'flags',
  orgFeatures: 'orgFeatures',
  navLeftItems: 'navLeftItems',
  navRightItems: 'navRightItems',
  landingPath: 'landingPath',
  userMenuSections: 'userMenuSections',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ExperiencePresetScalarFieldEnum = (typeof ExperiencePresetScalarFieldEnum)[keyof typeof ExperiencePresetScalarFieldEnum]


export const OrgFeatureFlagScalarFieldEnum = {
  id: 'id',
  flagId: 'flagId',
  orgId: 'orgId',
  enabled: 'enabled'
} as const

export type OrgFeatureFlagScalarFieldEnum = (typeof OrgFeatureFlagScalarFieldEnum)[keyof typeof OrgFeatureFlagScalarFieldEnum]


export const SlackIntegrationScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  workspaceName: 'workspaceName',
  botToken: 'botToken',
  botUserId: 'botUserId',
  installedAt: 'installedAt',
  installedById: 'installedById',
  orgId: 'orgId',
  scopes: 'scopes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SlackIntegrationScalarFieldEnum = (typeof SlackIntegrationScalarFieldEnum)[keyof typeof SlackIntegrationScalarFieldEnum]


export const SlackChannelDigestConfigScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  workspaceId: 'workspaceId',
  slackChannelId: 'slackChannelId',
  channelName: 'channelName',
  enabled: 'enabled',
  enabledAt: 'enabledAt',
  enabledBy: 'enabledBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SlackChannelDigestConfigScalarFieldEnum = (typeof SlackChannelDigestConfigScalarFieldEnum)[keyof typeof SlackChannelDigestConfigScalarFieldEnum]


export const SlackCitizenshipViolationScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  workspaceId: 'workspaceId',
  attemptedKind: 'attemptedKind',
  attemptedChannel: 'attemptedChannel',
  attemptedUser: 'attemptedUser',
  summonContext: 'summonContext',
  errorMessage: 'errorMessage',
  occurredAt: 'occurredAt'
} as const

export type SlackCitizenshipViolationScalarFieldEnum = (typeof SlackCitizenshipViolationScalarFieldEnum)[keyof typeof SlackCitizenshipViolationScalarFieldEnum]


export const SlackChannelBackfillJobScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  status: 'status',
  joined: 'joined',
  skipped: 'skipped',
  alreadyIn: 'alreadyIn',
  failed: 'failed',
  total: 'total',
  resumeCursor: 'resumeCursor',
  retryCount: 'retryCount',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SlackChannelBackfillJobScalarFieldEnum = (typeof SlackChannelBackfillJobScalarFieldEnum)[keyof typeof SlackChannelBackfillJobScalarFieldEnum]


export const HubSpotConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  accessTokenCipher: 'accessTokenCipher',
  refreshTokenCipher: 'refreshTokenCipher',
  expiresAt: 'expiresAt',
  grantedScopes: 'grantedScopes',
  hubspotPortalId: 'hubspotPortalId',
  connectedAt: 'connectedAt',
  lastSyncAt: 'lastSyncAt',
  syncStatus: 'syncStatus',
  lastError: 'lastError',
  lastSyncCursor: 'lastSyncCursor',
  syncProgress: 'syncProgress',
  autoSyncEnabled: 'autoSyncEnabled',
  syncIntervalMin: 'syncIntervalMin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type HubSpotConnectionScalarFieldEnum = (typeof HubSpotConnectionScalarFieldEnum)[keyof typeof HubSpotConnectionScalarFieldEnum]


export const GitHubAppInstallationScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  installationId: 'installationId',
  accountLogin: 'accountLogin',
  accountType: 'accountType',
  repositorySelection: 'repositorySelection',
  permissions: 'permissions',
  events: 'events',
  installedByPersonId: 'installedByPersonId',
  installedAt: 'installedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  suspendedAt: 'suspendedAt'
} as const

export type GitHubAppInstallationScalarFieldEnum = (typeof GitHubAppInstallationScalarFieldEnum)[keyof typeof GitHubAppInstallationScalarFieldEnum]


export const NotionWorkspaceConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  notionWorkspaceId: 'notionWorkspaceId',
  notionWorkspaceName: 'notionWorkspaceName',
  notionWorkspaceIcon: 'notionWorkspaceIcon',
  botUserId: 'botUserId',
  accessToken: 'accessToken',
  tokenType: 'tokenType',
  scopes: 'scopes',
  installedByPersonId: 'installedByPersonId',
  createdAt: 'createdAt',
  installedAt: 'installedAt',
  updatedAt: 'updatedAt'
} as const

export type NotionWorkspaceConnectionScalarFieldEnum = (typeof NotionWorkspaceConnectionScalarFieldEnum)[keyof typeof NotionWorkspaceConnectionScalarFieldEnum]


export const RipplingConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  apiKey: 'apiKey',
  apiUrl: 'apiUrl',
  autoSyncEnabled: 'autoSyncEnabled',
  lastSyncAt: 'lastSyncAt',
  syncStatus: 'syncStatus',
  lastError: 'lastError',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RipplingConnectionScalarFieldEnum = (typeof RipplingConnectionScalarFieldEnum)[keyof typeof RipplingConnectionScalarFieldEnum]


export const IntegrationConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  integrationKey: 'integrationKey',
  encryptedData: 'encryptedData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IntegrationConnectionScalarFieldEnum = (typeof IntegrationConnectionScalarFieldEnum)[keyof typeof IntegrationConnectionScalarFieldEnum]


export const IntegrationConnectionHealthScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  integrationKey: 'integrationKey',
  status: 'status',
  reason: 'reason',
  since: 'since',
  lastCheckedAt: 'lastCheckedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IntegrationConnectionHealthScalarFieldEnum = (typeof IntegrationConnectionHealthScalarFieldEnum)[keyof typeof IntegrationConnectionHealthScalarFieldEnum]


export const PersonIntegrationConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  integrationKey: 'integrationKey',
  credentialKind: 'credentialKind',
  encryptedData: 'encryptedData',
  externalAccountEmail: 'externalAccountEmail',
  status: 'status',
  lastSyncedAt: 'lastSyncedAt',
  syncCursor: 'syncCursor',
  lastError: 'lastError',
  connectedAt: 'connectedAt',
  revokedAt: 'revokedAt',
  eventNoteTermsAcknowledgedAt: 'eventNoteTermsAcknowledgedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonIntegrationConnectionScalarFieldEnum = (typeof PersonIntegrationConnectionScalarFieldEnum)[keyof typeof PersonIntegrationConnectionScalarFieldEnum]


export const HubSpotWebhookEventScalarFieldEnum = {
  id: 'id',
  eventId: 'eventId',
  subscriptionType: 'subscriptionType',
  objectId: 'objectId',
  occurredAt: 'occurredAt',
  processedAt: 'processedAt',
  success: 'success',
  error: 'error',
  createdAt: 'createdAt'
} as const

export type HubSpotWebhookEventScalarFieldEnum = (typeof HubSpotWebhookEventScalarFieldEnum)[keyof typeof HubSpotWebhookEventScalarFieldEnum]


export const ReplyScalarFieldEnum = {
  id: 'id',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authorId: 'authorId',
  parentType: 'parentType',
  parentId: 'parentId',
  updateId: 'updateId',
  changelogId: 'changelogId',
  commentId: 'commentId',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  viewingAsUserId: 'viewingAsUserId'
} as const

export type ReplyScalarFieldEnum = (typeof ReplyScalarFieldEnum)[keyof typeof ReplyScalarFieldEnum]


export const ReactionScalarFieldEnum = {
  id: 'id',
  emoji: 'emoji',
  createdAt: 'createdAt',
  personId: 'personId',
  targetType: 'targetType',
  targetId: 'targetId',
  commentId: 'commentId',
  replyId: 'replyId',
  updateId: 'updateId',
  reflectionId: 'reflectionId',
  meetingHighlightId: 'meetingHighlightId',
  evidenceId: 'evidenceId',
  beliefId: 'beliefId',
  orgId: 'orgId'
} as const

export type ReactionScalarFieldEnum = (typeof ReactionScalarFieldEnum)[keyof typeof ReactionScalarFieldEnum]


export const MetricsDashboardScalarFieldEnum = {
  id: 'id',
  name: 'name',
  icon: 'icon',
  description: 'description',
  displayOrder: 'displayOrder',
  isActive: 'isActive',
  captainId: 'captainId',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MetricsDashboardScalarFieldEnum = (typeof MetricsDashboardScalarFieldEnum)[keyof typeof MetricsDashboardScalarFieldEnum]


export const DashboardItemScalarFieldEnum = {
  id: 'id',
  dashboardId: 'dashboardId',
  name: 'name',
  description: 'description',
  goal: 'goal',
  actual: 'actual',
  status: 'status',
  captainId: 'captainId',
  notes: 'notes',
  displayOrder: 'displayOrder',
  lastUpdatedAt: 'lastUpdatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DashboardItemScalarFieldEnum = (typeof DashboardItemScalarFieldEnum)[keyof typeof DashboardItemScalarFieldEnum]


export const DashboardItemHistoryScalarFieldEnum = {
  id: 'id',
  itemId: 'itemId',
  goal: 'goal',
  actual: 'actual',
  description: 'description',
  status: 'status',
  notes: 'notes',
  reviewId: 'reviewId',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type DashboardItemHistoryScalarFieldEnum = (typeof DashboardItemHistoryScalarFieldEnum)[keyof typeof DashboardItemHistoryScalarFieldEnum]


export const DashboardItemLinkScalarFieldEnum = {
  id: 'id',
  dashboardItemId: 'dashboardItemId',
  linkedItemType: 'linkedItemType',
  rockId: 'rockId',
  groupId: 'groupId',
  projectId: 'projectId',
  displayOrder: 'displayOrder',
  notes: 'notes',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type DashboardItemLinkScalarFieldEnum = (typeof DashboardItemLinkScalarFieldEnum)[keyof typeof DashboardItemLinkScalarFieldEnum]


export const REKSCriteriaScalarFieldEnum = {
  id: 'id',
  groupId: 'groupId',
  dimension: 'dimension',
  expectations: 'expectations',
  rubricUrl: 'rubricUrl',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  proposedById: 'proposedById',
  proposedAt: 'proposedAt',
  approvedById: 'approvedById',
  approvedAt: 'approvedAt'
} as const

export type REKSCriteriaScalarFieldEnum = (typeof REKSCriteriaScalarFieldEnum)[keyof typeof REKSCriteriaScalarFieldEnum]


export const WeeklyReflectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  userId: 'userId',
  weekOf: 'weekOf',
  content: 'content',
  isDraft: 'isDraft',
  submittedAt: 'submittedAt',
  importedFrom: 'importedFrom',
  submissionId: 'submissionId',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  viewingAsUserId: 'viewingAsUserId'
} as const

export type WeeklyReflectionScalarFieldEnum = (typeof WeeklyReflectionScalarFieldEnum)[keyof typeof WeeklyReflectionScalarFieldEnum]


export const PulseCheckReviewScalarFieldEnum = {
  id: 'id',
  reflectionId: 'reflectionId',
  reviewerId: 'reviewerId',
  reviewedAt: 'reviewedAt',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PulseCheckReviewScalarFieldEnum = (typeof PulseCheckReviewScalarFieldEnum)[keyof typeof PulseCheckReviewScalarFieldEnum]


export const PulseCheckShareScalarFieldEnum = {
  id: 'id',
  reflectionId: 'reflectionId',
  sharedById: 'sharedById',
  sharedWithId: 'sharedWithId',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PulseCheckShareScalarFieldEnum = (typeof PulseCheckShareScalarFieldEnum)[keyof typeof PulseCheckShareScalarFieldEnum]


export const PulseConversationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reflectionId: 'reflectionId',
  userId: 'userId',
  status: 'status',
  completedAt: 'completedAt',
  source: 'source',
  runCount: 'runCount',
  lockedFieldsByItem: 'lockedFieldsByItem',
  messagesJson: 'messagesJson',
  globalCheckInDirectives: 'globalCheckInDirectives',
  extractedUpdates: 'extractedUpdates',
  contextWorkItems: 'contextWorkItems',
  itemSummaries: 'itemSummaries',
  conversationMetadata: 'conversationMetadata',
  heavinessScore: 'heavinessScore',
  lastSeenSynopsisId: 'lastSeenSynopsisId',
  extractionSuggestions: 'extractionSuggestions',
  model: 'model',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  orgId: 'orgId',
  viewingAsUserId: 'viewingAsUserId',
  reviewPeriodId: 'reviewPeriodId',
  quarterlyReviewPeriodId: 'quarterlyReviewPeriodId',
  pulseId: 'pulseId',
  orgUnitId: 'orgUnitId',
  envelopePulseId: 'envelopePulseId',
  subjectType: 'subjectType',
  purposeConfigVersion: 'purposeConfigVersion'
} as const

export type PulseConversationScalarFieldEnum = (typeof PulseConversationScalarFieldEnum)[keyof typeof PulseConversationScalarFieldEnum]


export const PulseConversationMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  conversationId: 'conversationId',
  role: 'role',
  content: 'content',
  timestamp: 'timestamp',
  workItemId: 'workItemId',
  workItemType: 'workItemType',
  toolCalls: 'toolCalls',
  toolResults: 'toolResults',
  sentiment: 'sentiment',
  orderIndex: 'orderIndex',
  orgId: 'orgId'
} as const

export type PulseConversationMessageScalarFieldEnum = (typeof PulseConversationMessageScalarFieldEnum)[keyof typeof PulseConversationMessageScalarFieldEnum]


export const PulseConversationAnnotationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conversationId: 'conversationId',
  messageId: 'messageId',
  workItemId: 'workItemId',
  workItemType: 'workItemType',
  authorId: 'authorId',
  text: 'text',
  flaggedForOneOnOne: 'flaggedForOneOnOne',
  needsAttention: 'needsAttention',
  orgId: 'orgId'
} as const

export type PulseConversationAnnotationScalarFieldEnum = (typeof PulseConversationAnnotationScalarFieldEnum)[keyof typeof PulseConversationAnnotationScalarFieldEnum]


export const PulsePersonalizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  depthPreference: 'depthPreference',
  engagedTopics: 'engagedTopics',
  briefTopics: 'briefTopics',
  communicationStyle: 'communicationStyle',
  wrapUpPattern: 'wrapUpPattern',
  depthPreferenceOverride: 'depthPreferenceOverride',
  communicationStyleOverride: 'communicationStyleOverride',
  wrapUpPatternOverride: 'wrapUpPatternOverride',
  teamCheckInDepth: 'teamCheckInDepth',
  teamCheckInDepthOverride: 'teamCheckInDepthOverride',
  conversationCount: 'conversationCount',
  updatesDepthPreference: 'updatesDepthPreference',
  updatesDepthPreferenceOverride: 'updatesDepthPreferenceOverride',
  adaptivePacingEnabled: 'adaptivePacingEnabled',
  smartResurfacing: 'smartResurfacing',
  personalizedPrioritization: 'personalizedPrioritization',
  orgId: 'orgId'
} as const

export type PulsePersonalizationScalarFieldEnum = (typeof PulsePersonalizationScalarFieldEnum)[keyof typeof PulsePersonalizationScalarFieldEnum]


export const PulseWorkItemPassLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  orgId: 'orgId',
  workItemType: 'workItemType',
  subjectId: 'subjectId',
  passedAt: 'passedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PulseWorkItemPassLogScalarFieldEnum = (typeof PulseWorkItemPassLogScalarFieldEnum)[keyof typeof PulseWorkItemPassLogScalarFieldEnum]


export const PulseUserTypeAffinityScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  userId: 'userId',
  workItemType: 'workItemType',
  engagementScore: 'engagementScore',
  engagementBias: 'engagementBias',
  createdAt: 'createdAt'
} as const

export type PulseUserTypeAffinityScalarFieldEnum = (typeof PulseUserTypeAffinityScalarFieldEnum)[keyof typeof PulseUserTypeAffinityScalarFieldEnum]


export const PulseConversationMemoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  type: 'type',
  content: 'content',
  weekOf: 'weekOf',
  relatedItemIds: 'relatedItemIds',
  relevanceScore: 'relevanceScore',
  orgId: 'orgId',
  expiresAt: 'expiresAt'
} as const

export type PulseConversationMemoryScalarFieldEnum = (typeof PulseConversationMemoryScalarFieldEnum)[keyof typeof PulseConversationMemoryScalarFieldEnum]


export const AiBeliefCorrectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  surfaceType: 'surfaceType',
  surfaceConversationId: 'surfaceConversationId',
  surfaceMessageId: 'surfaceMessageId',
  category: 'category',
  aiBelief: 'aiBelief',
  userTruth: 'userTruth',
  entityType: 'entityType',
  entityId: 'entityId',
  status: 'status',
  supersededBy: 'supersededBy',
  data: 'data',
  providerName: 'providerName',
  orgId: 'orgId'
} as const

export type AiBeliefCorrectionScalarFieldEnum = (typeof AiBeliefCorrectionScalarFieldEnum)[keyof typeof AiBeliefCorrectionScalarFieldEnum]


export const SystemPromptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  promptText: 'promptText',
  updatedById: 'updatedById',
  orgId: 'orgId'
} as const

export type SystemPromptScalarFieldEnum = (typeof SystemPromptScalarFieldEnum)[keyof typeof SystemPromptScalarFieldEnum]


export const ConfigVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  configKind: 'configKind',
  configKey: 'configKey',
  payload: 'payload',
  payloadHash: 'payloadHash',
  baseDefaultHash: 'baseDefaultHash',
  authorId: 'authorId',
  note: 'note',
  orgId: 'orgId'
} as const

export type ConfigVersionScalarFieldEnum = (typeof ConfigVersionScalarFieldEnum)[keyof typeof ConfigVersionScalarFieldEnum]


export const AiModelOverrideScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  featureKey: 'featureKey',
  modelId: 'modelId',
  updatedById: 'updatedById',
  orgId: 'orgId'
} as const

export type AiModelOverrideScalarFieldEnum = (typeof AiModelOverrideScalarFieldEnum)[keyof typeof AiModelOverrideScalarFieldEnum]


export const EmailTemplateScalarFieldEnum = {
  id: 'id',
  key: 'key',
  subjectTemplate: 'subjectTemplate',
  htmlTemplate: 'htmlTemplate',
  textTemplate: 'textTemplate',
  markdownTemplate: 'markdownTemplate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  orgId: 'orgId'
} as const

export type EmailTemplateScalarFieldEnum = (typeof EmailTemplateScalarFieldEnum)[keyof typeof EmailTemplateScalarFieldEnum]


export const PulseTeamSynthesisScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  managerId: 'managerId',
  weekOf: 'weekOf',
  synthesisJson: 'synthesisJson',
  reportsIncluded: 'reportsIncluded',
  completedCount: 'completedCount',
  totalReports: 'totalReports',
  model: 'model',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  orgId: 'orgId'
} as const

export type PulseTeamSynthesisScalarFieldEnum = (typeof PulseTeamSynthesisScalarFieldEnum)[keyof typeof PulseTeamSynthesisScalarFieldEnum]


export const PersonPulseSynthesisScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  personId: 'personId',
  requestedById: 'requestedById',
  synthesisJson: 'synthesisJson',
  pulseCheckCount: 'pulseCheckCount',
  model: 'model',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  orgId: 'orgId'
} as const

export type PersonPulseSynthesisScalarFieldEnum = (typeof PersonPulseSynthesisScalarFieldEnum)[keyof typeof PersonPulseSynthesisScalarFieldEnum]


export const PulseInsightsSummaryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reflectionId: 'reflectionId',
  insightsJson: 'insightsJson',
  model: 'model',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  orgId: 'orgId'
} as const

export type PulseInsightsSummaryScalarFieldEnum = (typeof PulseInsightsSummaryScalarFieldEnum)[keyof typeof PulseInsightsSummaryScalarFieldEnum]


export const AffectSignalScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  sourceKind: 'sourceKind',
  sourceId: 'sourceId',
  valence: 'valence',
  intensity: 'intensity',
  emotions: 'emotions',
  targetKind: 'targetKind',
  targetRef: 'targetRef',
  targetLabel: 'targetLabel',
  evidenceQuote: 'evidenceQuote',
  confidence: 'confidence',
  occurredAt: 'occurredAt',
  createdAt: 'createdAt'
} as const

export type AffectSignalScalarFieldEnum = (typeof AffectSignalScalarFieldEnum)[keyof typeof AffectSignalScalarFieldEnum]


export const PerformanceReviewScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  reviewerId: 'reviewerId',
  reviewType: 'reviewType',
  isOfficial: 'isOfficial',
  periodId: 'periodId',
  selfEvaluationWindowId: 'selfEvaluationWindowId',
  periodYear: 'periodYear',
  periodMonth: 'periodMonth',
  resultsStatus: 'resultsStatus',
  effortStatus: 'effortStatus',
  knowledgeStatus: 'knowledgeStatus',
  skillsStatus: 'skillsStatus',
  resultsCalculatedScore: 'resultsCalculatedScore',
  effortCalculatedScore: 'effortCalculatedScore',
  knowledgeCalculatedScore: 'knowledgeCalculatedScore',
  skillsCalculatedScore: 'skillsCalculatedScore',
  resultsOverrideJustification: 'resultsOverrideJustification',
  effortOverrideJustification: 'effortOverrideJustification',
  knowledgeOverrideJustification: 'knowledgeOverrideJustification',
  skillsOverrideJustification: 'skillsOverrideJustification',
  overallValuesStatus: 'overallValuesStatus',
  pulseChecksStatus: 'pulseChecksStatus',
  pulseChecksCompletionPercentage: 'pulseChecksCompletionPercentage',
  pulseChecksWeeksCompleted: 'pulseChecksWeeksCompleted',
  pulseChecksWeeksTotal: 'pulseChecksWeeksTotal',
  calculatedOverallStatus: 'calculatedOverallStatus',
  overallStatus: 'overallStatus',
  overallStatusOverride: 'overallStatusOverride',
  overrideReason: 'overrideReason',
  recommendation: 'recommendation',
  reksNote: 'reksNote',
  valuesNote: 'valuesNote',
  additionalNotes: 'additionalNotes',
  sharedAt: 'sharedAt',
  viewedByEmployeeAt: 'viewedByEmployeeAt',
  criteriaSnapshot: 'criteriaSnapshot',
  criteriaSnapshotDate: 'criteriaSnapshotDate',
  suggestionMetadata: 'suggestionMetadata',
  isAnonymousToEmployee: 'isAnonymousToEmployee',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PerformanceReviewScalarFieldEnum = (typeof PerformanceReviewScalarFieldEnum)[keyof typeof PerformanceReviewScalarFieldEnum]


export const ReviewDateArchiveScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sourceTable: 'sourceTable',
  sourceId: 'sourceId',
  reviewDate: 'reviewDate',
  archivedAt: 'archivedAt'
} as const

export type ReviewDateArchiveScalarFieldEnum = (typeof ReviewDateArchiveScalarFieldEnum)[keyof typeof ReviewDateArchiveScalarFieldEnum]


export const PerformanceReviewValueRatingScalarFieldEnum = {
  id: 'id',
  performanceReviewId: 'performanceReviewId',
  value: 'value',
  coreValueDefinitionId: 'coreValueDefinitionId',
  rating: 'rating',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PerformanceReviewValueRatingScalarFieldEnum = (typeof PerformanceReviewValueRatingScalarFieldEnum)[keyof typeof PerformanceReviewValueRatingScalarFieldEnum]


export const PerformanceReviewValueExceptionScalarFieldEnum = {
  id: 'id',
  performanceReviewId: 'performanceReviewId',
  coreValueDefinitionId: 'coreValueDefinitionId',
  direction: 'direction',
  severity: 'severity',
  note: 'note',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PerformanceReviewValueExceptionScalarFieldEnum = (typeof PerformanceReviewValueExceptionScalarFieldEnum)[keyof typeof PerformanceReviewValueExceptionScalarFieldEnum]


export const DashboardItemReviewScalarFieldEnum = {
  id: 'id',
  itemId: 'itemId',
  reviewerId: 'reviewerId',
  periodYear: 'periodYear',
  periodMonth: 'periodMonth',
  period: 'period',
  sessionId: 'sessionId',
  status: 'status',
  notes: 'notes',
  goal: 'goal',
  actual: 'actual',
  description: 'description',
  ranking: 'ranking',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type DashboardItemReviewScalarFieldEnum = (typeof DashboardItemReviewScalarFieldEnum)[keyof typeof DashboardItemReviewScalarFieldEnum]


export const DashboardReviewDraftScalarFieldEnum = {
  id: 'id',
  dashboardId: 'dashboardId',
  reviewerId: 'reviewerId',
  periodYear: 'periodYear',
  periodMonth: 'periodMonth',
  period: 'period',
  draftData: 'draftData',
  currentIndex: 'currentIndex',
  lastSaved: 'lastSaved',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type DashboardReviewDraftScalarFieldEnum = (typeof DashboardReviewDraftScalarFieldEnum)[keyof typeof DashboardReviewDraftScalarFieldEnum]


export const DashboardReviewSessionScalarFieldEnum = {
  id: 'id',
  dashboardId: 'dashboardId',
  reviewerId: 'reviewerId',
  periodYear: 'periodYear',
  periodMonth: 'periodMonth',
  period: 'period',
  overallNotes: 'overallNotes',
  scorePercent: 'scorePercent',
  scoreActual: 'scoreActual',
  scoreMax: 'scoreMax',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type DashboardReviewSessionScalarFieldEnum = (typeof DashboardReviewSessionScalarFieldEnum)[keyof typeof DashboardReviewSessionScalarFieldEnum]


export const FeedbackScalarFieldEnum = {
  id: 'id',
  type: 'type',
  message: 'message',
  pageUrl: 'pageUrl',
  screenshotUrl: 'screenshotUrl',
  captureMetadata: 'captureMetadata',
  status: 'status',
  safetyDecision: 'safetyDecision',
  safetyCategories: 'safetyCategories',
  safetyRationale: 'safetyRationale',
  safetyScreenedAt: 'safetyScreenedAt',
  userId: 'userId',
  viewingAsUserId: 'viewingAsUserId',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  sessionId: 'sessionId',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type FeedbackScalarFieldEnum = (typeof FeedbackScalarFieldEnum)[keyof typeof FeedbackScalarFieldEnum]


export const FeedbackCommentScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  authorId: 'authorId',
  message: 'message',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type FeedbackCommentScalarFieldEnum = (typeof FeedbackCommentScalarFieldEnum)[keyof typeof FeedbackCommentScalarFieldEnum]


export const FeedbackActivityScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  actorId: 'actorId',
  type: 'type',
  fromStatus: 'fromStatus',
  toStatus: 'toStatus',
  metadata: 'metadata',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type FeedbackActivityScalarFieldEnum = (typeof FeedbackActivityScalarFieldEnum)[keyof typeof FeedbackActivityScalarFieldEnum]


export const FeedbackViewScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  userId: 'userId',
  viewedAt: 'viewedAt',
  orgId: 'orgId'
} as const

export type FeedbackViewScalarFieldEnum = (typeof FeedbackViewScalarFieldEnum)[keyof typeof FeedbackViewScalarFieldEnum]


export const FeedbackAnchorScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  feedbackId: 'feedbackId',
  selectorPath: 'selectorPath',
  anchorKind: 'anchorKind',
  fragile: 'fragile',
  pinRect: 'pinRect',
  route: 'route',
  label: 'label',
  surfaceName: 'surfaceName',
  createdAt: 'createdAt'
} as const

export type FeedbackAnchorScalarFieldEnum = (typeof FeedbackAnchorScalarFieldEnum)[keyof typeof FeedbackAnchorScalarFieldEnum]


export const FeedbackSessionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  userId: 'userId',
  consentAt: 'consentAt',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  chunkCount: 'chunkCount'
} as const

export type FeedbackSessionScalarFieldEnum = (typeof FeedbackSessionScalarFieldEnum)[keyof typeof FeedbackSessionScalarFieldEnum]


export const REKSMeasurableLinkScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  measureId: 'measureId',
  dimension: 'dimension',
  weight: 'weight',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type REKSMeasurableLinkScalarFieldEnum = (typeof REKSMeasurableLinkScalarFieldEnum)[keyof typeof REKSMeasurableLinkScalarFieldEnum]


export const AiAuditResponseScalarFieldEnum = {
  id: 'id',
  provenanceId: 'provenanceId',
  rawResponse: 'rawResponse',
  modelId: 'modelId',
  promptHash: 'promptHash',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  success: 'success',
  failureReason: 'failureReason',
  personId: 'personId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AiAuditResponseScalarFieldEnum = (typeof AiAuditResponseScalarFieldEnum)[keyof typeof AiAuditResponseScalarFieldEnum]


export const PatternViewScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  lastViewedAt: 'lastViewedAt',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PatternViewScalarFieldEnum = (typeof PatternViewScalarFieldEnum)[keyof typeof PatternViewScalarFieldEnum]


export const PatternCacheScalarFieldEnum = {
  id: 'id',
  clusters: 'clusters',
  duplicates: 'duplicates',
  computedAt: 'computedAt',
  expiresAt: 'expiresAt',
  orgId: 'orgId'
} as const

export type PatternCacheScalarFieldEnum = (typeof PatternCacheScalarFieldEnum)[keyof typeof PatternCacheScalarFieldEnum]


export const KnowledgeGraphCacheScalarFieldEnum = {
  id: 'id',
  nodes: 'nodes',
  edges: 'edges',
  computedAt: 'computedAt',
  expiresAt: 'expiresAt',
  orgId: 'orgId'
} as const

export type KnowledgeGraphCacheScalarFieldEnum = (typeof KnowledgeGraphCacheScalarFieldEnum)[keyof typeof KnowledgeGraphCacheScalarFieldEnum]


export const PerformanceReviewSettingsScalarFieldEnum = {
  id: 'id',
  recurringRule: 'recurringRule',
  timezone: 'timezone',
  quarterlyReksWeight: 'quarterlyReksWeight',
  quarterlyValuesWeight: 'quarterlyValuesWeight',
  sprintAnchorDate: 'sprintAnchorDate',
  sprintLengthWeeks: 'sprintLengthWeeks',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PerformanceReviewSettingsScalarFieldEnum = (typeof PerformanceReviewSettingsScalarFieldEnum)[keyof typeof PerformanceReviewSettingsScalarFieldEnum]


export const PerformanceReviewPeriodScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  year: 'year',
  month: 'month',
  startDate: 'startDate',
  endDate: 'endDate',
  isCustom: 'isCustom',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PerformanceReviewPeriodScalarFieldEnum = (typeof PerformanceReviewPeriodScalarFieldEnum)[keyof typeof PerformanceReviewPeriodScalarFieldEnum]


export const TeamLeadAssignmentScalarFieldEnum = {
  id: 'id',
  periodId: 'periodId',
  teamLeadId: 'teamLeadId',
  personId: 'personId',
  assignedById: 'assignedById',
  orgId: 'orgId',
  createdAt: 'createdAt'
} as const

export type TeamLeadAssignmentScalarFieldEnum = (typeof TeamLeadAssignmentScalarFieldEnum)[keyof typeof TeamLeadAssignmentScalarFieldEnum]


export const SelfEvaluationWindowScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  year: 'year',
  quarter: 'quarter',
  startDate: 'startDate',
  endDate: 'endDate',
  isCustom: 'isCustom',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SelfEvaluationWindowScalarFieldEnum = (typeof SelfEvaluationWindowScalarFieldEnum)[keyof typeof SelfEvaluationWindowScalarFieldEnum]


export const SelfReflectionDraftScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  windowId: 'windowId',
  orgId: 'orgId',
  draftData: 'draftData',
  currentStep: 'currentStep',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
} as const

export type SelfReflectionDraftScalarFieldEnum = (typeof SelfReflectionDraftScalarFieldEnum)[keyof typeof SelfReflectionDraftScalarFieldEnum]


export const FormDraftScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  formKey: 'formKey',
  orgId: 'orgId',
  draftData: 'draftData',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
} as const

export type FormDraftScalarFieldEnum = (typeof FormDraftScalarFieldEnum)[keyof typeof FormDraftScalarFieldEnum]


export const QuarterlyPerformanceReviewScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  reviewerId: 'reviewerId',
  year: 'year',
  quarter: 'quarter',
  reksStatus: 'reksStatus',
  valuesStatus: 'valuesStatus',
  overallStatus: 'overallStatus',
  notes: 'notes',
  executiveNotes: 'executiveNotes',
  reksWeight: 'reksWeight',
  valuesWeight: 'valuesWeight',
  status: 'status',
  rejectionNote: 'rejectionNote',
  executiveReviewerId: 'executiveReviewerId',
  executiveReviewedAt: 'executiveReviewedAt',
  calibratedById: 'calibratedById',
  calibratedAt: 'calibratedAt',
  sharedAt: 'sharedAt',
  sharedByUserId: 'sharedByUserId',
  viewedByEmployeeAt: 'viewedByEmployeeAt',
  levelProposalTitle: 'levelProposalTitle',
  levelProposalLevel: 'levelProposalLevel',
  levelProposalNotes: 'levelProposalNotes',
  proposedTrackId: 'proposedTrackId',
  proposedLevelNumber: 'proposedLevelNumber',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuarterlyPerformanceReviewScalarFieldEnum = (typeof QuarterlyPerformanceReviewScalarFieldEnum)[keyof typeof QuarterlyPerformanceReviewScalarFieldEnum]


export const QuarterlyReviewRecommendationScalarFieldEnum = {
  id: 'id',
  quarterlyReviewId: 'quarterlyReviewId',
  recommendedReksStatus: 'recommendedReksStatus',
  recommendedValuesStatus: 'recommendedValuesStatus',
  recommendedOverallStatus: 'recommendedOverallStatus',
  narrative: 'narrative',
  signalCallouts: 'signalCallouts',
  inputSummary: 'inputSummary',
  modelVersion: 'modelVersion',
  lastInputSignature: 'lastInputSignature',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuarterlyReviewRecommendationScalarFieldEnum = (typeof QuarterlyReviewRecommendationScalarFieldEnum)[keyof typeof QuarterlyReviewRecommendationScalarFieldEnum]


export const QuarterlyReviewCheckInScalarFieldEnum = {
  id: 'id',
  quarterlyReviewId: 'quarterlyReviewId',
  performanceReviewId: 'performanceReviewId',
  isOfficialMonthly: 'isOfficialMonthly',
  orgId: 'orgId'
} as const

export type QuarterlyReviewCheckInScalarFieldEnum = (typeof QuarterlyReviewCheckInScalarFieldEnum)[keyof typeof QuarterlyReviewCheckInScalarFieldEnum]


export const QuarterlyReviewEditHistoryScalarFieldEnum = {
  id: 'id',
  quarterlyReviewId: 'quarterlyReviewId',
  editorId: 'editorId',
  editedAt: 'editedAt',
  changesJson: 'changesJson',
  orgId: 'orgId'
} as const

export type QuarterlyReviewEditHistoryScalarFieldEnum = (typeof QuarterlyReviewEditHistoryScalarFieldEnum)[keyof typeof QuarterlyReviewEditHistoryScalarFieldEnum]


export const QuarterlyReviewPeriodScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  year: 'year',
  quarter: 'quarter',
  startDate: 'startDate',
  endDate: 'endDate',
  executiveDeadline: 'executiveDeadline',
  isCustom: 'isCustom',
  includeLeveling: 'includeLeveling',
  remindersSuppressed: 'remindersSuppressed',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuarterlyReviewPeriodScalarFieldEnum = (typeof QuarterlyReviewPeriodScalarFieldEnum)[keyof typeof QuarterlyReviewPeriodScalarFieldEnum]


export const EvaluationCadenceScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  key: 'key',
  enabled: 'enabled',
  priority: 'priority',
  yieldsToHigherPriority: 'yieldsToHigherPriority',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EvaluationCadenceScalarFieldEnum = (typeof EvaluationCadenceScalarFieldEnum)[keyof typeof EvaluationCadenceScalarFieldEnum]


export const ContractorCheckInScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  reviewerId: 'reviewerId',
  periodId: 'periodId',
  status: 'status',
  recommendation: 'recommendation',
  notes: 'notes',
  sharedAt: 'sharedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type ContractorCheckInScalarFieldEnum = (typeof ContractorCheckInScalarFieldEnum)[keyof typeof ContractorCheckInScalarFieldEnum]


export const PeerReviewNominationScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  nomineeId: 'nomineeId',
  nominatedById: 'nominatedById',
  periodId: 'periodId',
  status: 'status',
  reviewType: 'reviewType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PeerReviewNominationScalarFieldEnum = (typeof PeerReviewNominationScalarFieldEnum)[keyof typeof PeerReviewNominationScalarFieldEnum]


export const ReviewSynthesisScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  periodId: 'periodId',
  summary: 'summary',
  blindSpots: 'blindSpots',
  underselling: 'underselling',
  consensus: 'consensus',
  coachingTopics: 'coachingTopics',
  strengthThemes: 'strengthThemes',
  growthThemes: 'growthThemes',
  dimensionAnalysis: 'dimensionAnalysis',
  managerNotes: 'managerNotes',
  finalizedAt: 'finalizedAt',
  finalizedById: 'finalizedById',
  reviewCount: 'reviewCount',
  reviewTypes: 'reviewTypes',
  modelUsed: 'modelUsed',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type ReviewSynthesisScalarFieldEnum = (typeof ReviewSynthesisScalarFieldEnum)[keyof typeof ReviewSynthesisScalarFieldEnum]


export const PlanScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  type: 'type',
  isSystem: 'isSystem',
  targetType: 'targetType',
  creatorId: 'creatorId',
  status: 'status',
  mergedAt: 'mergedAt',
  mergedById: 'mergedById',
  archivedAt: 'archivedAt',
  archivedById: 'archivedById',
  orgId: 'orgId',
  isPublic: 'isPublic',
  sourceVersionId: 'sourceVersionId',
  versionName: 'versionName',
  sentForReviewAt: 'sentForReviewAt',
  acceptanceDeadline: 'acceptanceDeadline',
  sentForReviewById: 'sentForReviewById',
  sourceRockId: 'sourceRockId',
  targetParentRockId: 'targetParentRockId',
  targetParentProjectId: 'targetParentProjectId',
  targetParentPriorityId: 'targetParentPriorityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  viewingAsUserId: 'viewingAsUserId',
  workloadScope: 'workloadScope'
} as const

export type PlanScalarFieldEnum = (typeof PlanScalarFieldEnum)[keyof typeof PlanScalarFieldEnum]


export const PlanItemScalarFieldEnum = {
  id: 'id',
  planId: 'planId',
  title: 'title',
  charter: 'charter',
  rationale: 'rationale',
  captainId: 'captainId',
  ownerId: 'ownerId',
  parentId: 'parentId',
  manualOrder: 'manualOrder',
  mergeDecision: 'mergeDecision',
  mappedToRockId: 'mappedToRockId',
  mergedRockId: 'mergedRockId',
  mappedToPriorityId: 'mappedToPriorityId',
  mergedPriorityId: 'mergedPriorityId',
  mappedToProjectId: 'mappedToProjectId',
  mergedProjectId: 'mergedProjectId',
  mappedToOutcomeId: 'mappedToOutcomeId',
  mergedOutcomeId: 'mergedOutcomeId',
  targetType: 'targetType',
  associatedPriorityId: 'associatedPriorityId',
  associatedRockId: 'associatedRockId',
  aiSuggestedRockId: 'aiSuggestedRockId',
  aiSimilarityScore: 'aiSimilarityScore',
  orgId: 'orgId',
  isPrivate: 'isPrivate',
  startDate: 'startDate',
  targetDate: 'targetDate',
  proposedById: 'proposedById',
  proposalState: 'proposalState',
  lastModifiedRole: 'lastModifiedRole',
  proposalTimestamp: 'proposalTimestamp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PlanItemScalarFieldEnum = (typeof PlanItemScalarFieldEnum)[keyof typeof PlanItemScalarFieldEnum]


export const PlanLabelScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  planId: 'planId',
  entityKind: 'entityKind',
  entityId: 'entityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById'
} as const

export type PlanLabelScalarFieldEnum = (typeof PlanLabelScalarFieldEnum)[keyof typeof PlanLabelScalarFieldEnum]


export const PlanItemAcceptanceScalarFieldEnum = {
  id: 'id',
  planItemId: 'planItemId',
  captainId: 'captainId',
  status: 'status',
  concernMessage: 'concernMessage',
  overriddenAt: 'overriddenAt',
  overriddenById: 'overriddenById',
  overrideReason: 'overrideReason',
  acknowledgedAt: 'acknowledgedAt',
  acknowledgedById: 'acknowledgedById',
  respondedAt: 'respondedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PlanItemAcceptanceScalarFieldEnum = (typeof PlanItemAcceptanceScalarFieldEnum)[keyof typeof PlanItemAcceptanceScalarFieldEnum]


export const PlanItemVersionScalarFieldEnum = {
  id: 'id',
  planItemId: 'planItemId',
  title: 'title',
  charter: 'charter',
  rationale: 'rationale',
  measurables: 'measurables',
  contributors: 'contributors',
  changeStatus: 'changeStatus',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PlanItemVersionScalarFieldEnum = (typeof PlanItemVersionScalarFieldEnum)[keyof typeof PlanItemVersionScalarFieldEnum]


export const PlanItemProposalEditScalarFieldEnum = {
  id: 'id',
  planItemId: 'planItemId',
  proposedById: 'proposedById',
  editorRole: 'editorRole',
  originalValues: 'originalValues',
  changedFields: 'changedFields',
  proposalState: 'proposalState',
  resolvedAt: 'resolvedAt',
  resolvedById: 'resolvedById',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PlanItemProposalEditScalarFieldEnum = (typeof PlanItemProposalEditScalarFieldEnum)[keyof typeof PlanItemProposalEditScalarFieldEnum]


export const IdeaHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  title: 'title',
  charter: 'charter',
  submitterId: 'submitterId',
  status: 'status',
  processedById: 'processedById',
  processedAt: 'processedAt',
  resultingRockId: 'resultingRockId',
  resultingProjectId: 'resultingProjectId',
  resultingTaskId: 'resultingTaskId',
  targetPlanId: 'targetPlanId',
  submittedAt: 'submittedAt',
  orgId: 'orgId'
} as const

export type IdeaHistoryScalarFieldEnum = (typeof IdeaHistoryScalarFieldEnum)[keyof typeof IdeaHistoryScalarFieldEnum]


export const EditSessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  entityType: 'entityType',
  entityId: 'entityId',
  updateId: 'updateId',
  changelogId: 'changelogId',
  editedFields: 'editedFields',
  expiresAt: 'expiresAt',
  sessionType: 'sessionType',
  field: 'field',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type EditSessionScalarFieldEnum = (typeof EditSessionScalarFieldEnum)[keyof typeof EditSessionScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  recipientId: 'recipientId',
  type: 'type',
  title: 'title',
  message: 'message',
  actionUrl: 'actionUrl',
  actionLabel: 'actionLabel',
  priority: 'priority',
  entityType: 'entityType',
  entityId: 'entityId',
  payload: 'payload',
  isRead: 'isRead',
  isResolved: 'isResolved',
  readAt: 'readAt',
  resolvedAt: 'resolvedAt',
  snoozedUntil: 'snoozedUntil',
  dedupeKey: 'dedupeKey',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const NotificationDeliveryScalarFieldEnum = {
  id: 'id',
  notificationId: 'notificationId',
  channel: 'channel',
  status: 'status',
  sentAt: 'sentAt',
  failedAt: 'failedAt',
  failureReason: 'failureReason',
  retryCount: 'retryCount',
  nextRetryAt: 'nextRetryAt',
  externalId: 'externalId',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type NotificationDeliveryScalarFieldEnum = (typeof NotificationDeliveryScalarFieldEnum)[keyof typeof NotificationDeliveryScalarFieldEnum]


export const NotificationPreferenceScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  channel: 'channel',
  notificationType: 'notificationType',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type NotificationPreferenceScalarFieldEnum = (typeof NotificationPreferenceScalarFieldEnum)[keyof typeof NotificationPreferenceScalarFieldEnum]


export const NotificationDeliveryLogScalarFieldEnum = {
  id: 'id',
  notificationId: 'notificationId',
  recipientId: 'recipientId',
  recipientEmail: 'recipientEmail',
  notificationType: 'notificationType',
  source: 'source',
  inAppAttempted: 'inAppAttempted',
  inAppSucceeded: 'inAppSucceeded',
  inAppError: 'inAppError',
  emailAttempted: 'emailAttempted',
  emailSucceeded: 'emailSucceeded',
  emailError: 'emailError',
  slackAttempted: 'slackAttempted',
  slackSucceeded: 'slackSucceeded',
  slackError: 'slackError',
  payload: 'payload',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type NotificationDeliveryLogScalarFieldEnum = (typeof NotificationDeliveryLogScalarFieldEnum)[keyof typeof NotificationDeliveryLogScalarFieldEnum]


export const PerformanceAlertScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  type: 'type',
  severity: 'severity',
  title: 'title',
  message: 'message',
  relatedId: 'relatedId',
  relatedType: 'relatedType',
  isRead: 'isRead',
  isDismissed: 'isDismissed',
  readAt: 'readAt',
  dismissedAt: 'dismissedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  orgId: 'orgId'
} as const

export type PerformanceAlertScalarFieldEnum = (typeof PerformanceAlertScalarFieldEnum)[keyof typeof PerformanceAlertScalarFieldEnum]


export const ImpersonationLogScalarFieldEnum = {
  id: 'id',
  adminId: 'adminId',
  targetPersonId: 'targetPersonId',
  orgId: 'orgId',
  reason: 'reason',
  actions: 'actions',
  startedAt: 'startedAt',
  endedAt: 'endedAt'
} as const

export type ImpersonationLogScalarFieldEnum = (typeof ImpersonationLogScalarFieldEnum)[keyof typeof ImpersonationLogScalarFieldEnum]


export const AttachmentScalarFieldEnum = {
  id: 'id',
  attachableType: 'attachableType',
  attachableId: 'attachableId',
  storageKey: 'storageKey',
  fileName: 'fileName',
  mimeType: 'mimeType',
  sizeBytes: 'sizeBytes',
  uploadedById: 'uploadedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  orgId: 'orgId',
  thumbnailKey: 'thumbnailKey',
  thumbnailStatus: 'thumbnailStatus',
  pageCount: 'pageCount',
  extractedText: 'extractedText',
  extractionStatus: 'extractionStatus',
  readingEdit: 'readingEdit',
  readingEditedAt: 'readingEditedAt',
  readingEditedById: 'readingEditedById',
  messageId: 'messageId',
  aiChatMessageId: 'aiChatMessageId',
  sourceAttachmentId: 'sourceAttachmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AttachmentScalarFieldEnum = (typeof AttachmentScalarFieldEnum)[keyof typeof AttachmentScalarFieldEnum]


export const LinkAttachmentScalarFieldEnum = {
  id: 'id',
  attachableType: 'attachableType',
  attachableId: 'attachableId',
  url: 'url',
  title: 'title',
  domain: 'domain',
  faviconUrl: 'faviconUrl',
  thumbnailUrl: 'thumbnailUrl',
  mediaType: 'mediaType',
  providerName: 'providerName',
  durationSeconds: 'durationSeconds',
  summary: 'summary',
  summarizedAt: 'summarizedAt',
  contentHash: 'contentHash',
  readingEdit: 'readingEdit',
  readingEditedAt: 'readingEditedAt',
  readingEditedById: 'readingEditedById',
  createdById: 'createdById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  messageId: 'messageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LinkAttachmentScalarFieldEnum = (typeof LinkAttachmentScalarFieldEnum)[keyof typeof LinkAttachmentScalarFieldEnum]


export const TrainingItemScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  category: 'category',
  difficulty: 'difficulty',
  displayOrder: 'displayOrder',
  completionCriteria: 'completionCriteria',
  startPath: 'startPath',
  uiSections: 'uiSections',
  requiredRole: 'requiredRole',
  isActive: 'isActive',
  hintText: 'hintText',
  roles: 'roles',
  orgId: 'orgId'
} as const

export type TrainingItemScalarFieldEnum = (typeof TrainingItemScalarFieldEnum)[keyof typeof TrainingItemScalarFieldEnum]


export const TrainingPlanScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  isSystem: 'isSystem',
  isDefault: 'isDefault',
  isActive: 'isActive',
  isOnboarding: 'isOnboarding',
  sortOrder: 'sortOrder',
  unlockedByPlanId: 'unlockedByPlanId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type TrainingPlanScalarFieldEnum = (typeof TrainingPlanScalarFieldEnum)[keyof typeof TrainingPlanScalarFieldEnum]


export const TrainingPlanSectionScalarFieldEnum = {
  id: 'id',
  planId: 'planId',
  name: 'name',
  description: 'description',
  sortOrder: 'sortOrder',
  whyItMatters: 'whyItMatters',
  orgId: 'orgId'
} as const

export type TrainingPlanSectionScalarFieldEnum = (typeof TrainingPlanSectionScalarFieldEnum)[keyof typeof TrainingPlanSectionScalarFieldEnum]


export const TrainingPlanItemScalarFieldEnum = {
  id: 'id',
  planId: 'planId',
  itemId: 'itemId',
  displayOrder: 'displayOrder',
  sectionId: 'sectionId',
  dynamicCondition: 'dynamicCondition',
  orgId: 'orgId'
} as const

export type TrainingPlanItemScalarFieldEnum = (typeof TrainingPlanItemScalarFieldEnum)[keyof typeof TrainingPlanItemScalarFieldEnum]


export const TrainingAssignmentScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  planId: 'planId',
  assignedById: 'assignedById',
  assignedAt: 'assignedAt',
  dueDate: 'dueDate',
  completedAt: 'completedAt',
  status: 'status',
  hasSeenOnboardingWelcome: 'hasSeenOnboardingWelcome',
  unlockedAt: 'unlockedAt',
  orgId: 'orgId'
} as const

export type TrainingAssignmentScalarFieldEnum = (typeof TrainingAssignmentScalarFieldEnum)[keyof typeof TrainingAssignmentScalarFieldEnum]


export const TrainingItemProgressScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  itemId: 'itemId',
  completedAt: 'completedAt',
  completionSource: 'completionSource',
  metadata: 'metadata',
  celebrationSeenAt: 'celebrationSeenAt',
  orgId: 'orgId'
} as const

export type TrainingItemProgressScalarFieldEnum = (typeof TrainingItemProgressScalarFieldEnum)[keyof typeof TrainingItemProgressScalarFieldEnum]


export const AnnouncementScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  title: 'title',
  body: 'body',
  iconName: 'iconName',
  imageAttachmentId: 'imageAttachmentId',
  ctaLabel: 'ctaLabel',
  ctaUrl: 'ctaUrl',
  displayMode: 'displayMode',
  status: 'status',
  celebrate: 'celebrate',
  audience: 'audience',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  publishedAt: 'publishedAt',
  archivedAt: 'archivedAt',
  reminderBusinessDays: 'reminderBusinessDays',
  reminderChannels: 'reminderChannels',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AnnouncementScalarFieldEnum = (typeof AnnouncementScalarFieldEnum)[keyof typeof AnnouncementScalarFieldEnum]


export const AnnouncementRecipientScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  announcementId: 'announcementId',
  personId: 'personId',
  deliveredAt: 'deliveredAt',
  firstSeenAt: 'firstSeenAt',
  dismissedAt: 'dismissedAt',
  ctaClickedAt: 'ctaClickedAt',
  reminderDueAt: 'reminderDueAt',
  reminderSentAt: 'reminderSentAt'
} as const

export type AnnouncementRecipientScalarFieldEnum = (typeof AnnouncementRecipientScalarFieldEnum)[keyof typeof AnnouncementRecipientScalarFieldEnum]


export const ProfileQuestionnaireScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  outsideInterests: 'outsideInterests',
  surprisingFact: 'surprisingFact',
  communicationPref: 'communicationPref',
  communicationPrefs: 'communicationPrefs',
  skillsExpertise: 'skillsExpertise',
  canTeach: 'canTeach',
  toolsTechnologies: 'toolsTechnologies',
  futureVision: 'futureVision',
  skillsToDevelop: 'skillsToDevelop',
  excitingProjects: 'excitingProjects',
  whyJoined: 'whyJoined',
  lookingForwardTo: 'lookingForwardTo',
  noteForManager: 'noteForManager',
  completedAt: 'completedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type ProfileQuestionnaireScalarFieldEnum = (typeof ProfileQuestionnaireScalarFieldEnum)[keyof typeof ProfileQuestionnaireScalarFieldEnum]


export const PersonSensitiveDataScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  salaryInCents: 'salaryInCents',
  hourlyRateInCents: 'hourlyRateInCents',
  targetBonusPercent: 'targetBonusPercent',
  currency: 'currency',
  slackUserId: 'slackUserId',
  levelTrackId: 'levelTrackId',
  currentLevelNumber: 'currentLevelNumber',
  levelAssignedAt: 'levelAssignedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PersonSensitiveDataScalarFieldEnum = (typeof PersonSensitiveDataScalarFieldEnum)[keyof typeof PersonSensitiveDataScalarFieldEnum]


export const RockDependencyScalarFieldEnum = {
  id: 'id',
  blockingRockId: 'blockingRockId',
  blockedRockId: 'blockedRockId',
  createdAt: 'createdAt',
  createdById: 'createdById',
  orgId: 'orgId'
} as const

export type RockDependencyScalarFieldEnum = (typeof RockDependencyScalarFieldEnum)[keyof typeof RockDependencyScalarFieldEnum]


export const PlanItemDependencyScalarFieldEnum = {
  id: 'id',
  blockingPlanItemId: 'blockingPlanItemId',
  blockedPlanItemId: 'blockedPlanItemId',
  createdAt: 'createdAt',
  createdById: 'createdById',
  orgId: 'orgId'
} as const

export type PlanItemDependencyScalarFieldEnum = (typeof PlanItemDependencyScalarFieldEnum)[keyof typeof PlanItemDependencyScalarFieldEnum]


export const ProjectDependencyScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  dependencyType: 'dependencyType',
  dependencyProjectId: 'dependencyProjectId',
  dependencyRockId: 'dependencyRockId',
  direction: 'direction',
  createdAt: 'createdAt',
  createdById: 'createdById',
  orgId: 'orgId'
} as const

export type ProjectDependencyScalarFieldEnum = (typeof ProjectDependencyScalarFieldEnum)[keyof typeof ProjectDependencyScalarFieldEnum]


export const PersonWidgetPreferenceScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  instanceId: 'instanceId',
  widgetId: 'widgetId',
  isVisible: 'isVisible',
  displayOrder: 'displayOrder',
  settings: 'settings',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PersonWidgetPreferenceScalarFieldEnum = (typeof PersonWidgetPreferenceScalarFieldEnum)[keyof typeof PersonWidgetPreferenceScalarFieldEnum]


export const CoachingTopicScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  periodId: 'periodId',
  createdById: 'createdById',
  topic: 'topic',
  source: 'source',
  status: 'status',
  discussedAt: 'discussedAt',
  followUpNotes: 'followUpNotes',
  carriedForwardFromId: 'carriedForwardFromId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type CoachingTopicScalarFieldEnum = (typeof CoachingTopicScalarFieldEnum)[keyof typeof CoachingTopicScalarFieldEnum]


export const CoachingPrepNoteScalarFieldEnum = {
  id: 'id',
  managerId: 'managerId',
  employeeId: 'employeeId',
  periodId: 'periodId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type CoachingPrepNoteScalarFieldEnum = (typeof CoachingPrepNoteScalarFieldEnum)[keyof typeof CoachingPrepNoteScalarFieldEnum]


export const FeatureFlagScalarFieldEnum = {
  id: 'id',
  feature: 'feature',
  label: 'label',
  description: 'description',
  enabled: 'enabled',
  scope: 'scope',
  retirementIssueNumber: 'retirementIssueNumber',
  retirementStrategy: 'retirementStrategy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureFlagScalarFieldEnum = (typeof FeatureFlagScalarFieldEnum)[keyof typeof FeatureFlagScalarFieldEnum]


export const FeatureFlagUserOverrideScalarFieldEnum = {
  id: 'id',
  flagId: 'flagId',
  userId: 'userId',
  enabled: 'enabled',
  orgId: 'orgId',
  createdAt: 'createdAt'
} as const

export type FeatureFlagUserOverrideScalarFieldEnum = (typeof FeatureFlagUserOverrideScalarFieldEnum)[keyof typeof FeatureFlagUserOverrideScalarFieldEnum]


export const FeatureFlagRoleOverrideScalarFieldEnum = {
  id: 'id',
  flagId: 'flagId',
  role: 'role',
  enabled: 'enabled',
  orgId: 'orgId',
  createdAt: 'createdAt'
} as const

export type FeatureFlagRoleOverrideScalarFieldEnum = (typeof FeatureFlagRoleOverrideScalarFieldEnum)[keyof typeof FeatureFlagRoleOverrideScalarFieldEnum]


export const AiChatConversationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  title: 'title',
  archived: 'archived',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId',
  slackChannelId: 'slackChannelId',
  pulseId: 'pulseId'
} as const

export type AiChatConversationScalarFieldEnum = (typeof AiChatConversationScalarFieldEnum)[keyof typeof AiChatConversationScalarFieldEnum]


export const AiChatMessageScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  role: 'role',
  content: 'content',
  toolCalls: 'toolCalls',
  toolResults: 'toolResults',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  model: 'model',
  answerClass: 'answerClass',
  evidenceJson: 'evidenceJson',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type AiChatMessageScalarFieldEnum = (typeof AiChatMessageScalarFieldEnum)[keyof typeof AiChatMessageScalarFieldEnum]


export const AiChatMessageFeedbackScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  conversationId: 'conversationId',
  userId: 'userId',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type AiChatMessageFeedbackScalarFieldEnum = (typeof AiChatMessageFeedbackScalarFieldEnum)[keyof typeof AiChatMessageFeedbackScalarFieldEnum]


export const UnmetNeedScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  source: 'source',
  personId: 'personId',
  roleProfileDigest: 'roleProfileDigest',
  queryText: 'queryText',
  intents: 'intents',
  missingDomains: 'missingDomains',
  demandCategory: 'demandCategory',
  answerClass: 'answerClass',
  declinedRule: 'declinedRule',
  substitutesOffered: 'substitutesOffered',
  substituteAccepted: 'substituteAccepted',
  substituteAcceptedAt: 'substituteAcceptedAt',
  previewComponentsOffered: 'previewComponentsOffered',
  previewComponentsSelected: 'previewComponentsSelected',
  previewAnsweredAt: 'previewAnsweredAt',
  offRampsOffered: 'offRampsOffered',
  offRampTaken: 'offRampTaken',
  offRampTakenAt: 'offRampTakenAt',
  offRampsDismissed: 'offRampsDismissed',
  conversationId: 'conversationId',
  turnIndex: 'turnIndex',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UnmetNeedScalarFieldEnum = (typeof UnmetNeedScalarFieldEnum)[keyof typeof UnmetNeedScalarFieldEnum]


export const UnmetNeedMonitorScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  unmetNeedId: 'unmetNeedId',
  conversationId: 'conversationId',
  messageId: 'messageId',
  domain: 'domain',
  status: 'status',
  firedAt: 'firedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UnmetNeedMonitorScalarFieldEnum = (typeof UnmetNeedMonitorScalarFieldEnum)[keyof typeof UnmetNeedMonitorScalarFieldEnum]


export const AiChatResolvedEntityScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  conversationId: 'conversationId',
  turnIndex: 'turnIndex',
  askerPersonId: 'askerPersonId',
  nameText: 'nameText',
  matchCount: 'matchCount',
  resolvedPersonId: 'resolvedPersonId',
  resolvedIdentityId: 'resolvedIdentityId',
  personKind: 'personKind',
  resolution: 'resolution',
  offeredPersonIds: 'offeredPersonIds',
  pickedAt: 'pickedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AiChatResolvedEntityScalarFieldEnum = (typeof AiChatResolvedEntityScalarFieldEnum)[keyof typeof AiChatResolvedEntityScalarFieldEnum]


export const FeatureRecommendationScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  conversationId: 'conversationId',
  turnIndex: 'turnIndex',
  recommendationId: 'recommendationId',
  feature: 'feature',
  status: 'status',
  startedAt: 'startedAt',
  dismissedAt: 'dismissedAt',
  draftApprovedAt: 'draftApprovedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureRecommendationScalarFieldEnum = (typeof FeatureRecommendationScalarFieldEnum)[keyof typeof FeatureRecommendationScalarFieldEnum]


export const MentionExchangeScalarFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  channelId: 'channelId',
  orgId: 'orgId',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MentionExchangeScalarFieldEnum = (typeof MentionExchangeScalarFieldEnum)[keyof typeof MentionExchangeScalarFieldEnum]


export const SurveyScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  status: 'status',
  isAnonymous: 'isAnonymous',
  bucketGranularity: 'bucketGranularity',
  triggerType: 'triggerType',
  sendAt: 'sendAt',
  closesAt: 'closesAt',
  remindersEnabled: 'remindersEnabled',
  reminderFrequencyDays: 'reminderFrequencyDays',
  maxReminders: 'maxReminders',
  createdById: 'createdById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  aiSummary: 'aiSummary',
  audienceConfig: 'audienceConfig',
  clonedFromId: 'clonedFromId',
  parentSurveyId: 'parentSurveyId',
  recurringConfig: 'recurringConfig',
  recurrenceStartsAt: 'recurrenceStartsAt',
  recurrenceEndsAt: 'recurrenceEndsAt',
  systemKey: 'systemKey',
  minCohortSize: 'minCohortSize',
  cohortAorIds: 'cohortAorIds',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SurveyScalarFieldEnum = (typeof SurveyScalarFieldEnum)[keyof typeof SurveyScalarFieldEnum]


export const SurveyShareScalarFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  sharedWithId: 'sharedWithId',
  sharedById: 'sharedById',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type SurveyShareScalarFieldEnum = (typeof SurveyShareScalarFieldEnum)[keyof typeof SurveyShareScalarFieldEnum]


export const SurveyQuestionScalarFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  type: 'type',
  text: 'text',
  description: 'description',
  config: 'config',
  conditions: 'conditions',
  isRequired: 'isRequired',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type SurveyQuestionScalarFieldEnum = (typeof SurveyQuestionScalarFieldEnum)[keyof typeof SurveyQuestionScalarFieldEnum]


export const SurveyRecipientScalarFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  personId: 'personId',
  status: 'status',
  notifiedAt: 'notifiedAt',
  completedAt: 'completedAt',
  reminderCount: 'reminderCount',
  lastRemindedAt: 'lastRemindedAt',
  draftData: 'draftData',
  hasSubmitted: 'hasSubmitted',
  submittedBucket: 'submittedBucket',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type SurveyRecipientScalarFieldEnum = (typeof SurveyRecipientScalarFieldEnum)[keyof typeof SurveyRecipientScalarFieldEnum]


export const SurveyResponseScalarFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  respondentId: 'respondentId',
  submittedAt: 'submittedAt',
  submittedBucket: 'submittedBucket',
  cohort: 'cohort',
  cohortSnapshotAt: 'cohortSnapshotAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId',
  viewingAsUserId: 'viewingAsUserId'
} as const

export type SurveyResponseScalarFieldEnum = (typeof SurveyResponseScalarFieldEnum)[keyof typeof SurveyResponseScalarFieldEnum]


export const SurveyAnswerScalarFieldEnum = {
  id: 'id',
  responseId: 'responseId',
  questionId: 'questionId',
  ratingValue: 'ratingValue',
  textValue: 'textValue',
  choiceValues: 'choiceValues',
  sentiment: 'sentiment',
  orgId: 'orgId'
} as const

export type SurveyAnswerScalarFieldEnum = (typeof SurveyAnswerScalarFieldEnum)[keyof typeof SurveyAnswerScalarFieldEnum]


export const SurveyInsightDismissalScalarFieldEnum = {
  id: 'id',
  surveyId: 'surveyId',
  personId: 'personId',
  insightKey: 'insightKey',
  dismissedAt: 'dismissedAt',
  orgId: 'orgId'
} as const

export type SurveyInsightDismissalScalarFieldEnum = (typeof SurveyInsightDismissalScalarFieldEnum)[keyof typeof SurveyInsightDismissalScalarFieldEnum]


export const SurveyResponseCommentScalarFieldEnum = {
  id: 'id',
  responseId: 'responseId',
  authorId: 'authorId',
  message: 'message',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type SurveyResponseCommentScalarFieldEnum = (typeof SurveyResponseCommentScalarFieldEnum)[keyof typeof SurveyResponseCommentScalarFieldEnum]


export const SurveyTemplateScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  questions: 'questions',
  isBuiltIn: 'isBuiltIn',
  category: 'category',
  orgId: 'orgId',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SurveyTemplateScalarFieldEnum = (typeof SurveyTemplateScalarFieldEnum)[keyof typeof SurveyTemplateScalarFieldEnum]


export const QuestionBankItemScalarFieldEnum = {
  id: 'id',
  type: 'type',
  text: 'text',
  description: 'description',
  config: 'config',
  category: 'category',
  usageCount: 'usageCount',
  isBuiltIn: 'isBuiltIn',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuestionBankItemScalarFieldEnum = (typeof QuestionBankItemScalarFieldEnum)[keyof typeof QuestionBankItemScalarFieldEnum]


export const SurveySequenceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  eventType: 'eventType',
  isActive: 'isActive',
  createdById: 'createdById',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SurveySequenceScalarFieldEnum = (typeof SurveySequenceScalarFieldEnum)[keyof typeof SurveySequenceScalarFieldEnum]


export const SurveySequenceStepScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  name: 'name',
  delayDays: 'delayDays',
  position: 'position',
  templateId: 'templateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type SurveySequenceStepScalarFieldEnum = (typeof SurveySequenceStepScalarFieldEnum)[keyof typeof SurveySequenceStepScalarFieldEnum]


export const SurveySequenceEnrollmentScalarFieldEnum = {
  id: 'id',
  sequenceId: 'sequenceId',
  personId: 'personId',
  eventDate: 'eventDate',
  status: 'status',
  enrolledAt: 'enrolledAt',
  completedAt: 'completedAt',
  orgId: 'orgId'
} as const

export type SurveySequenceEnrollmentScalarFieldEnum = (typeof SurveySequenceEnrollmentScalarFieldEnum)[keyof typeof SurveySequenceEnrollmentScalarFieldEnum]


export const SurveySequenceStepExecutionScalarFieldEnum = {
  id: 'id',
  enrollmentId: 'enrollmentId',
  stepId: 'stepId',
  scheduledDate: 'scheduledDate',
  status: 'status',
  surveyId: 'surveyId',
  sentAt: 'sentAt',
  completedAt: 'completedAt',
  orgId: 'orgId'
} as const

export type SurveySequenceStepExecutionScalarFieldEnum = (typeof SurveySequenceStepExecutionScalarFieldEnum)[keyof typeof SurveySequenceStepExecutionScalarFieldEnum]


export const PulsePromptCustomizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  groupId: 'groupId',
  instructions: 'instructions',
  mode: 'mode',
  updatedById: 'updatedById',
  orgId: 'orgId'
} as const

export type PulsePromptCustomizationScalarFieldEnum = (typeof PulsePromptCustomizationScalarFieldEnum)[keyof typeof PulsePromptCustomizationScalarFieldEnum]


export const CheckInPromptCustomizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  groupId: 'groupId',
  instructions: 'instructions',
  mode: 'mode',
  updatedById: 'updatedById',
  orgId: 'orgId'
} as const

export type CheckInPromptCustomizationScalarFieldEnum = (typeof CheckInPromptCustomizationScalarFieldEnum)[keyof typeof CheckInPromptCustomizationScalarFieldEnum]


export const QuarterReviewScalarFieldEnum = {
  id: 'id',
  quarter: 'quarter',
  type: 'type',
  closedAt: 'closedAt',
  facilitatorId: 'facilitatorId',
  sessionLog: 'sessionLog',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type QuarterReviewScalarFieldEnum = (typeof QuarterReviewScalarFieldEnum)[keyof typeof QuarterReviewScalarFieldEnum]


export const RockReviewScalarFieldEnum = {
  id: 'id',
  rockId: 'rockId',
  priorityId: 'priorityId',
  reviewId: 'reviewId',
  disposition: 'disposition',
  notes: 'notes',
  confirmedById: 'confirmedById',
  starred: 'starred',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type RockReviewScalarFieldEnum = (typeof RockReviewScalarFieldEnum)[keyof typeof RockReviewScalarFieldEnum]


export const PulseReminderConfigScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type PulseReminderConfigScalarFieldEnum = (typeof PulseReminderConfigScalarFieldEnum)[keyof typeof PulseReminderConfigScalarFieldEnum]


export const PulseReminderScheduleScalarFieldEnum = {
  id: 'id',
  configId: 'configId',
  dayOfWeek: 'dayOfWeek',
  timeOfDay: 'timeOfDay',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PulseReminderScheduleScalarFieldEnum = (typeof PulseReminderScheduleScalarFieldEnum)[keyof typeof PulseReminderScheduleScalarFieldEnum]


export const PulseReminderIncludedUnitScalarFieldEnum = {
  id: 'id',
  configId: 'configId',
  unitId: 'unitId',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type PulseReminderIncludedUnitScalarFieldEnum = (typeof PulseReminderIncludedUnitScalarFieldEnum)[keyof typeof PulseReminderIncludedUnitScalarFieldEnum]


export const EventScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  eventType: 'eventType',
  category: 'category',
  entityType: 'entityType',
  entityId: 'entityId',
  mode: 'mode',
  hasAttachments: 'hasAttachments',
  attachmentCount: 'attachmentCount',
  properties: 'properties',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type EventScalarFieldEnum = (typeof EventScalarFieldEnum)[keyof typeof EventScalarFieldEnum]


export const JobFamilyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  displayOrder: 'displayOrder',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type JobFamilyScalarFieldEnum = (typeof JobFamilyScalarFieldEnum)[keyof typeof JobFamilyScalarFieldEnum]


export const JobFamilySpecializationScalarFieldEnum = {
  id: 'id',
  jobFamilyId: 'jobFamilyId',
  name: 'name',
  displayOrder: 'displayOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type JobFamilySpecializationScalarFieldEnum = (typeof JobFamilySpecializationScalarFieldEnum)[keyof typeof JobFamilySpecializationScalarFieldEnum]


export const LevelTrackScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  minLevel: 'minLevel',
  maxLevel: 'maxLevel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LevelTrackScalarFieldEnum = (typeof LevelTrackScalarFieldEnum)[keyof typeof LevelTrackScalarFieldEnum]


export const LevelDimensionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  displayOrder: 'displayOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LevelDimensionScalarFieldEnum = (typeof LevelDimensionScalarFieldEnum)[keyof typeof LevelDimensionScalarFieldEnum]


export const LevelDefinitionScalarFieldEnum = {
  id: 'id',
  trackId: 'trackId',
  levelNumber: 'levelNumber',
  levelName: 'levelName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LevelDefinitionScalarFieldEnum = (typeof LevelDefinitionScalarFieldEnum)[keyof typeof LevelDefinitionScalarFieldEnum]


export const LevelTitleScalarFieldEnum = {
  id: 'id',
  jobFamilyId: 'jobFamilyId',
  specializationId: 'specializationId',
  trackId: 'trackId',
  levelNumber: 'levelNumber',
  exampleTitle: 'exampleTitle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LevelTitleScalarFieldEnum = (typeof LevelTitleScalarFieldEnum)[keyof typeof LevelTitleScalarFieldEnum]


export const LevelDimensionDescriptionScalarFieldEnum = {
  id: 'id',
  levelDefinitionId: 'levelDefinitionId',
  dimensionId: 'dimensionId',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LevelDimensionDescriptionScalarFieldEnum = (typeof LevelDimensionDescriptionScalarFieldEnum)[keyof typeof LevelDimensionDescriptionScalarFieldEnum]


export const CalibrationCycleScalarFieldEnum = {
  id: 'id',
  quarter: 'quarter',
  status: 'status',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type CalibrationCycleScalarFieldEnum = (typeof CalibrationCycleScalarFieldEnum)[keyof typeof CalibrationCycleScalarFieldEnum]


export const CalibrationParticipantGrantScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  cycleId: 'cycleId',
  grantedById: 'grantedById',
  grantedAt: 'grantedAt',
  revokedAt: 'revokedAt',
  revokedById: 'revokedById',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CalibrationParticipantGrantScalarFieldEnum = (typeof CalibrationParticipantGrantScalarFieldEnum)[keyof typeof CalibrationParticipantGrantScalarFieldEnum]


export const CalibrationNoteScalarFieldEnum = {
  id: 'id',
  cycleId: 'cycleId',
  personId: 'personId',
  authorId: 'authorId',
  noteType: 'noteType',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type CalibrationNoteScalarFieldEnum = (typeof CalibrationNoteScalarFieldEnum)[keyof typeof CalibrationNoteScalarFieldEnum]


export const LevelProposalScalarFieldEnum = {
  id: 'id',
  cycleId: 'cycleId',
  personId: 'personId',
  proposedById: 'proposedById',
  currentTrackId: 'currentTrackId',
  currentLevelNumber: 'currentLevelNumber',
  proposedTrackId: 'proposedTrackId',
  proposedLevelNumber: 'proposedLevelNumber',
  justification: 'justification',
  proposedTitle: 'proposedTitle',
  status: 'status',
  reviewedById: 'reviewedById',
  reviewNote: 'reviewNote',
  reviewedAt: 'reviewedAt',
  quarterlyReviewId: 'quarterlyReviewId',
  quarterlyReviewRecordId: 'quarterlyReviewRecordId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type LevelProposalScalarFieldEnum = (typeof LevelProposalScalarFieldEnum)[keyof typeof LevelProposalScalarFieldEnum]


export const BonusPeriodScalarFieldEnum = {
  id: 'id',
  quarter: 'quarter',
  type: 'type',
  status: 'status',
  personalSplitPercent: 'personalSplitPercent',
  companySplitPercent: 'companySplitPercent',
  companyMultiplier: 'companyMultiplier',
  createdById: 'createdById',
  finalizedAt: 'finalizedAt',
  finalizedById: 'finalizedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId'
} as const

export type BonusPeriodScalarFieldEnum = (typeof BonusPeriodScalarFieldEnum)[keyof typeof BonusPeriodScalarFieldEnum]


export const BonusRecordScalarFieldEnum = {
  id: 'id',
  periodId: 'periodId',
  personId: 'personId',
  salarySnapshot: 'salarySnapshot',
  targetBonusPercent: 'targetBonusPercent',
  reksStatus: 'reksStatus',
  valuesStatus: 'valuesStatus',
  payoutPercent: 'payoutPercent',
  prorateRatio: 'prorateRatio',
  personalSplitPercent: 'personalSplitPercent',
  companySplitPercent: 'companySplitPercent',
  companyMultiplier: 'companyMultiplier',
  quarterlyTargetInCents: 'quarterlyTargetInCents',
  personalAmountInCents: 'personalAmountInCents',
  companyAmountInCents: 'companyAmountInCents',
  totalAmountInCents: 'totalAmountInCents',
  isEligible: 'isEligible',
  ineligibilityReason: 'ineligibilityReason',
  overrideAmountInCents: 'overrideAmountInCents',
  overrideReason: 'overrideReason',
  overriddenById: 'overriddenById',
  overriddenAt: 'overriddenAt',
  overridePayoutPercent: 'overridePayoutPercent',
  createdAt: 'createdAt',
  orgId: 'orgId'
} as const

export type BonusRecordScalarFieldEnum = (typeof BonusRecordScalarFieldEnum)[keyof typeof BonusRecordScalarFieldEnum]


export const TodayBriefScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  orgId: 'orgId',
  date: 'date',
  content: 'content',
  generatedAt: 'generatedAt',
  manualRegenerationCount: 'manualRegenerationCount',
  lastManualRegeneratedAt: 'lastManualRegeneratedAt',
  focusChangeRegenerationCount: 'focusChangeRegenerationCount',
  lastFocusChangeRegeneratedAt: 'lastFocusChangeRegeneratedAt',
  model: 'model',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens'
} as const

export type TodayBriefScalarFieldEnum = (typeof TodayBriefScalarFieldEnum)[keyof typeof TodayBriefScalarFieldEnum]


export const CronJobRunScalarFieldEnum = {
  id: 'id',
  jobName: 'jobName',
  startedAt: 'startedAt',
  duration: 'duration',
  success: 'success',
  summary: 'summary',
  error: 'error',
  outcome: 'outcome'
} as const

export type CronJobRunScalarFieldEnum = (typeof CronJobRunScalarFieldEnum)[keyof typeof CronJobRunScalarFieldEnum]


export const PlatformAuditLogScalarFieldEnum = {
  id: 'id',
  actorPersonId: 'actorPersonId',
  reason: 'reason',
  metadata: 'metadata',
  createdAt: 'createdAt',
  targetOrgId: 'targetOrgId',
  action: 'action'
} as const

export type PlatformAuditLogScalarFieldEnum = (typeof PlatformAuditLogScalarFieldEnum)[keyof typeof PlatformAuditLogScalarFieldEnum]


export const FieldProvenanceScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  entityType: 'entityType',
  entityId: 'entityId',
  fieldName: 'fieldName',
  sourceSystem: 'sourceSystem',
  sourceRecordId: 'sourceRecordId',
  lastSyncedAt: 'lastSyncedAt',
  syncDirection: 'syncDirection',
  isManualOverride: 'isManualOverride',
  pendingSourceValue: 'pendingSourceValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FieldProvenanceScalarFieldEnum = (typeof FieldProvenanceScalarFieldEnum)[keyof typeof FieldProvenanceScalarFieldEnum]


export const SyncEventScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sourceSystem: 'sourceSystem',
  entityType: 'entityType',
  entityId: 'entityId',
  fieldName: 'fieldName',
  previousValue: 'previousValue',
  newValue: 'newValue',
  syncDirection: 'syncDirection',
  outcome: 'outcome',
  syncedAt: 'syncedAt',
  syncJobId: 'syncJobId',
  errorMessage: 'errorMessage'
} as const

export type SyncEventScalarFieldEnum = (typeof SyncEventScalarFieldEnum)[keyof typeof SyncEventScalarFieldEnum]


export const SyncEventDailySummaryScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sourceSystem: 'sourceSystem',
  entityType: 'entityType',
  date: 'date',
  outcome: 'outcome',
  count: 'count',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SyncEventDailySummaryScalarFieldEnum = (typeof SyncEventDailySummaryScalarFieldEnum)[keyof typeof SyncEventDailySummaryScalarFieldEnum]


export const PipRequestScalarFieldEnum = {
  id: 'id',
  requestingPersonId: 'requestingPersonId',
  targetPersonId: 'targetPersonId',
  reason: 'reason',
  status: 'status',
  convertedAt: 'convertedAt',
  convertedById: 'convertedById',
  convertedToPipId: 'convertedToPipId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PipRequestScalarFieldEnum = (typeof PipRequestScalarFieldEnum)[keyof typeof PipRequestScalarFieldEnum]


export const PipScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  managerId: 'managerId',
  createdById: 'createdById',
  requestId: 'requestId',
  status: 'status',
  statusAtCreation: 'statusAtCreation',
  statusSourceType: 'statusSourceType',
  statusSourceId: 'statusSourceId',
  statusSourceDate: 'statusSourceDate',
  statusSourceRecordId: 'statusSourceRecordId',
  objectives: 'objectives',
  blockers: 'blockers',
  outcomeNotes: 'outcomeNotes',
  startDate: 'startDate',
  endDate: 'endDate',
  outcome: 'outcome',
  closedAt: 'closedAt',
  closedById: 'closedById',
  supersedesId: 'supersedesId',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  endReminderSentAt: 'endReminderSentAt',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PipScalarFieldEnum = (typeof PipScalarFieldEnum)[keyof typeof PipScalarFieldEnum]


export const PipMeasurableScalarFieldEnum = {
  id: 'id',
  pipId: 'pipId',
  measureId: 'measureId',
  targetValue: 'targetValue',
  notes: 'notes',
  baselineValue: 'baselineValue',
  baselineReadingId: 'baselineReadingId',
  baselineRecordedAt: 'baselineRecordedAt',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PipMeasurableScalarFieldEnum = (typeof PipMeasurableScalarFieldEnum)[keyof typeof PipMeasurableScalarFieldEnum]


export const PipWeeklyReviewScalarFieldEnum = {
  id: 'id',
  pipId: 'pipId',
  weekNumber: 'weekNumber',
  scheduledDate: 'scheduledDate',
  coachingNote: 'coachingNote',
  employeeNote: 'employeeNote',
  managerNote: 'managerNote',
  employeeFilledAt: 'employeeFilledAt',
  managerFilledAt: 'managerFilledAt',
  completedAt: 'completedAt',
  emailedAt: 'emailedAt',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PipWeeklyReviewScalarFieldEnum = (typeof PipWeeklyReviewScalarFieldEnum)[keyof typeof PipWeeklyReviewScalarFieldEnum]


export const PipSignatureScalarFieldEnum = {
  id: 'id',
  pipId: 'pipId',
  signerId: 'signerId',
  impersonatedById: 'impersonatedById',
  impersonationReason: 'impersonationReason',
  role: 'role',
  signedAt: 'signedAt',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
  orgId: 'orgId'
} as const

export type PipSignatureScalarFieldEnum = (typeof PipSignatureScalarFieldEnum)[keyof typeof PipSignatureScalarFieldEnum]


export const PipActivityScalarFieldEnum = {
  id: 'id',
  pipId: 'pipId',
  actorId: 'actorId',
  actorImpersonatedId: 'actorImpersonatedId',
  action: 'action',
  changesJson: 'changesJson',
  orgId: 'orgId',
  createdAt: 'createdAt'
} as const

export type PipActivityScalarFieldEnum = (typeof PipActivityScalarFieldEnum)[keyof typeof PipActivityScalarFieldEnum]


export const CertificationScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  certName: 'certName',
  issuer: 'issuer',
  issuedDate: 'issuedDate',
  expiryDate: 'expiryDate',
  status: 'status',
  credentialId: 'credentialId',
  notes: 'notes',
  revokedAt: 'revokedAt',
  revokedReason: 'revokedReason',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CertificationScalarFieldEnum = (typeof CertificationScalarFieldEnum)[keyof typeof CertificationScalarFieldEnum]


export const AttendanceRecordScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  date: 'date',
  status: 'status',
  schoolId: 'schoolId',
  notes: 'notes',
  externalId: 'externalId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unitId: 'unitId'
} as const

export type AttendanceRecordScalarFieldEnum = (typeof AttendanceRecordScalarFieldEnum)[keyof typeof AttendanceRecordScalarFieldEnum]


export const AssessmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  startDate: 'startDate',
  endDate: 'endDate',
  assessmentCategory: 'assessmentCategory',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentScalarFieldEnum = (typeof AssessmentScalarFieldEnum)[keyof typeof AssessmentScalarFieldEnum]


export const AssessmentSectionScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  name: 'name',
  description: 'description',
  position: 'position',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentSectionScalarFieldEnum = (typeof AssessmentSectionScalarFieldEnum)[keyof typeof AssessmentSectionScalarFieldEnum]


export const AssessmentItemScalarFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  position: 'position',
  prompt: 'prompt',
  scoringModel: 'scoringModel',
  maxRawScore: 'maxRawScore',
  scaleId: 'scaleId',
  scaleMin: 'scaleMin',
  scaleMax: 'scaleMax',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentItemScalarFieldEnum = (typeof AssessmentItemScalarFieldEnum)[keyof typeof AssessmentItemScalarFieldEnum]


export const AssessmentResponseScalarFieldEnum = {
  id: 'id',
  itemId: 'itemId',
  personId: 'personId',
  rawScore: 'rawScore',
  scaleScore: 'scaleScore',
  proficiencyLevel: 'proficiencyLevel',
  achievementPercentile: 'achievementPercentile',
  growthPercentile: 'growthPercentile',
  appliedAccommodationId: 'appliedAccommodationId',
  scoreAdjustmentBefore: 'scoreAdjustmentBefore',
  scoreAdjustmentAfter: 'scoreAdjustmentAfter',
  notes: 'notes',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentResponseScalarFieldEnum = (typeof AssessmentResponseScalarFieldEnum)[keyof typeof AssessmentResponseScalarFieldEnum]


export const AssessmentAccommodationScalarFieldEnum = {
  id: 'id',
  assessmentId: 'assessmentId',
  personId: 'personId',
  accommodationType: 'accommodationType',
  notes: 'notes',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssessmentAccommodationScalarFieldEnum = (typeof AssessmentAccommodationScalarFieldEnum)[keyof typeof AssessmentAccommodationScalarFieldEnum]


export const MeetingOccurrenceScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  title: 'title',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  phase: 'phase',
  currentSectionId: 'currentSectionId',
  scheduledMinutes: 'scheduledMinutes',
  isPrivate: 'isPrivate',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  attendanceConfirmedAt: 'attendanceConfirmedAt',
  attendanceConfirmedById: 'attendanceConfirmedById',
  sectionNotesFoldedAt: 'sectionNotesFoldedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agendaId: 'agendaId',
  practiceId: 'practiceId'
} as const

export type MeetingOccurrenceScalarFieldEnum = (typeof MeetingOccurrenceScalarFieldEnum)[keyof typeof MeetingOccurrenceScalarFieldEnum]


export const MeetingAttendeeScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  meetingId: 'meetingId',
  participantId: 'participantId',
  source: 'source',
  role: 'role',
  presence: 'presence',
  presenceSource: 'presenceSource',
  presenceRecordedAt: 'presenceRecordedAt',
  addedById: 'addedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeetingAttendeeScalarFieldEnum = (typeof MeetingAttendeeScalarFieldEnum)[keyof typeof MeetingAttendeeScalarFieldEnum]


export const MeetingShareScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  meetingId: 'meetingId',
  recipientParticipantId: 'recipientParticipantId',
  sharedById: 'sharedById',
  sharedAt: 'sharedAt',
  grantsAccess: 'grantsAccess'
} as const

export type MeetingShareScalarFieldEnum = (typeof MeetingShareScalarFieldEnum)[keyof typeof MeetingShareScalarFieldEnum]


export const MeetingAgendaScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  name: 'name',
  defaultForOrgId: 'defaultForOrgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  practiceId: 'practiceId'
} as const

export type MeetingAgendaScalarFieldEnum = (typeof MeetingAgendaScalarFieldEnum)[keyof typeof MeetingAgendaScalarFieldEnum]


export const MeetingAgendaSectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  agendaId: 'agendaId',
  type: 'type',
  slug: 'slug',
  title: 'title',
  subtitle: 'subtitle',
  position: 'position',
  minutes: 'minutes',
  config: 'config',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeetingAgendaSectionScalarFieldEnum = (typeof MeetingAgendaSectionScalarFieldEnum)[keyof typeof MeetingAgendaSectionScalarFieldEnum]


export const MeetingSectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  occurrenceId: 'occurrenceId',
  type: 'type',
  slug: 'slug',
  title: 'title',
  subtitle: 'subtitle',
  position: 'position',
  minutes: 'minutes',
  config: 'config',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeetingSectionScalarFieldEnum = (typeof MeetingSectionScalarFieldEnum)[keyof typeof MeetingSectionScalarFieldEnum]


export const MeetingPrivateNoteScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  occurrenceId: 'occurrenceId',
  authorParticipantId: 'authorParticipantId',
  body: 'body',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeetingPrivateNoteScalarFieldEnum = (typeof MeetingPrivateNoteScalarFieldEnum)[keyof typeof MeetingPrivateNoteScalarFieldEnum]


export const MeetingSummaryScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  authorParticipantId: 'authorParticipantId',
  openingParagraph: 'openingParagraph',
  sections: 'sections',
  sourceKind: 'sourceKind',
  transcriptTruncated: 'transcriptTruncated',
  model: 'model',
  origin: 'origin',
  inputSources: 'inputSources',
  assessment: 'assessment',
  generatedAt: 'generatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeetingSummaryScalarFieldEnum = (typeof MeetingSummaryScalarFieldEnum)[keyof typeof MeetingSummaryScalarFieldEnum]


export const ObservationCycleNoteScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  observerParticipantId: 'observerParticipantId',
  observedParticipantId: 'observedParticipantId',
  body: 'body',
  cycleStart: 'cycleStart',
  cycleEnd: 'cycleEnd',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ObservationCycleNoteScalarFieldEnum = (typeof ObservationCycleNoteScalarFieldEnum)[keyof typeof ObservationCycleNoteScalarFieldEnum]


export const KynetaMetaScalarFieldEnum = {
  docId: 'docId',
  data: 'data',
  lastSeqAt: 'lastSeqAt'
} as const

export type KynetaMetaScalarFieldEnum = (typeof KynetaMetaScalarFieldEnum)[keyof typeof KynetaMetaScalarFieldEnum]


export const KynetaRecordScalarFieldEnum = {
  docId: 'docId',
  seq: 'seq',
  kind: 'kind',
  payload: 'payload',
  blob: 'blob'
} as const

export type KynetaRecordScalarFieldEnum = (typeof KynetaRecordScalarFieldEnum)[keyof typeof KynetaRecordScalarFieldEnum]


export const KynetaStoreMetaScalarFieldEnum = {
  key: 'key',
  value: 'value'
} as const

export type KynetaStoreMetaScalarFieldEnum = (typeof KynetaStoreMetaScalarFieldEnum)[keyof typeof KynetaStoreMetaScalarFieldEnum]


export const DisciplineIncidentScalarFieldEnum = {
  id: 'id',
  incidentIdentifier: 'incidentIdentifier',
  incidentType: 'incidentType',
  incidentDate: 'incidentDate',
  location: 'location',
  schoolYear: 'schoolYear',
  zeroTolerance: 'zeroTolerance',
  description: 'description',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DisciplineIncidentScalarFieldEnum = (typeof DisciplineIncidentScalarFieldEnum)[keyof typeof DisciplineIncidentScalarFieldEnum]


export const StudentDisciplineIncidentAssociationScalarFieldEnum = {
  id: 'id',
  incidentId: 'incidentId',
  studentId: 'studentId',
  participantIdentityId: 'participantIdentityId',
  behavioralRole: 'behavioralRole',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentDisciplineIncidentAssociationScalarFieldEnum = (typeof StudentDisciplineIncidentAssociationScalarFieldEnum)[keyof typeof StudentDisciplineIncidentAssociationScalarFieldEnum]


export const DisciplineActionScalarFieldEnum = {
  id: 'id',
  incidentId: 'incidentId',
  actionIdentifier: 'actionIdentifier',
  actionType: 'actionType',
  startDate: 'startDate',
  endDate: 'endDate',
  durationDays: 'durationDays',
  lengthDifferenceReason: 'lengthDifferenceReason',
  behaviorIncidentId: 'behaviorIncidentId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DisciplineActionScalarFieldEnum = (typeof DisciplineActionScalarFieldEnum)[keyof typeof DisciplineActionScalarFieldEnum]


export const BehaviorIncidentScalarFieldEnum = {
  id: 'id',
  externalId: 'externalId',
  participantIdentityId: 'participantIdentityId',
  reporterIdentityId: 'reporterIdentityId',
  incidentDate: 'incidentDate',
  incidentTime: 'incidentTime',
  locationDescriptor: 'locationDescriptor',
  behaviorCategory: 'behaviorCategory',
  behaviorDescriptor: 'behaviorDescriptor',
  severity: 'severity',
  points: 'points',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BehaviorIncidentScalarFieldEnum = (typeof BehaviorIncidentScalarFieldEnum)[keyof typeof BehaviorIncidentScalarFieldEnum]


export const StudentDemographicScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  schoolYear: 'schoolYear',
  gender: 'gender',
  isHispanicLatino: 'isHispanicLatino',
  economicDisadvantageStatus: 'economicDisadvantageStatus',
  elStatus: 'elStatus',
  disabilityStatus: 'disabilityStatus',
  isHomeless: 'isHomeless',
  isMigrant: 'isMigrant',
  primaryLanguage: 'primaryLanguage',
  languageProficiency: 'languageProficiency',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentDemographicScalarFieldEnum = (typeof StudentDemographicScalarFieldEnum)[keyof typeof StudentDemographicScalarFieldEnum]


export const StudentRaceScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  schoolYear: 'schoolYear',
  race: 'race',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentRaceScalarFieldEnum = (typeof StudentRaceScalarFieldEnum)[keyof typeof StudentRaceScalarFieldEnum]


export const AcademicTermScalarFieldEnum = {
  id: 'id',
  name: 'name',
  termType: 'termType',
  schoolYear: 'schoolYear',
  startDate: 'startDate',
  endDate: 'endDate',
  descriptor: 'descriptor',
  externalId: 'externalId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AcademicTermScalarFieldEnum = (typeof AcademicTermScalarFieldEnum)[keyof typeof AcademicTermScalarFieldEnum]


export const LinearWorkspaceConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  linearWorkspaceId: 'linearWorkspaceId',
  linearWorkspaceName: 'linearWorkspaceName',
  linearWorkspaceUrlKey: 'linearWorkspaceUrlKey',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  tokenExpiresAt: 'tokenExpiresAt',
  scopes: 'scopes',
  installedByPersonId: 'installedByPersonId',
  createdAt: 'createdAt',
  installedAt: 'installedAt',
  updatedAt: 'updatedAt',
  revokedAt: 'revokedAt'
} as const

export type LinearWorkspaceConnectionScalarFieldEnum = (typeof LinearWorkspaceConnectionScalarFieldEnum)[keyof typeof LinearWorkspaceConnectionScalarFieldEnum]


export const GoogleCalendarConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  serviceAccountEmail: 'serviceAccountEmail',
  encryptedPrivateKey: 'encryptedPrivateKey',
  installedByPersonId: 'installedByPersonId',
  installedAt: 'installedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GoogleCalendarConnectionScalarFieldEnum = (typeof GoogleCalendarConnectionScalarFieldEnum)[keyof typeof GoogleCalendarConnectionScalarFieldEnum]


export const GoogleGmailConnectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  serviceAccountEmail: 'serviceAccountEmail',
  encryptedPrivateKey: 'encryptedPrivateKey',
  installedByPersonId: 'installedByPersonId',
  installedAt: 'installedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GoogleGmailConnectionScalarFieldEnum = (typeof GoogleGmailConnectionScalarFieldEnum)[keyof typeof GoogleGmailConnectionScalarFieldEnum]


export const SchoolCalendarScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  schoolYear: 'schoolYear',
  name: 'name',
  schoolCode: 'schoolCode',
  totalInstructionalDays: 'totalInstructionalDays',
  descriptor: 'descriptor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SchoolCalendarScalarFieldEnum = (typeof SchoolCalendarScalarFieldEnum)[keyof typeof SchoolCalendarScalarFieldEnum]


export const SchoolCalendarDateScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  calendarId: 'calendarId',
  date: 'date',
  dayType: 'dayType',
  instructionalMinutes: 'instructionalMinutes',
  descriptor: 'descriptor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SchoolCalendarDateScalarFieldEnum = (typeof SchoolCalendarDateScalarFieldEnum)[keyof typeof SchoolCalendarDateScalarFieldEnum]


export const CourseScalarFieldEnum = {
  id: 'id',
  courseCode: 'courseCode',
  title: 'title',
  description: 'description',
  creditValue: 'creditValue',
  subject: 'subject',
  levelDescriptor: 'levelDescriptor',
  department: 'department',
  status: 'status',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CourseScalarFieldEnum = (typeof CourseScalarFieldEnum)[keyof typeof CourseScalarFieldEnum]


export const CourseSectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  courseId: 'courseId',
  termId: 'termId',
  sectionIdentifier: 'sectionIdentifier',
  primaryInstructorId: 'primaryInstructorId',
  schoolCode: 'schoolCode',
  unitId: 'unitId',
  locationDescription: 'locationDescription',
  availableCredits: 'availableCredits',
  descriptor: 'descriptor',
  status: 'status',
  fieldProvenance: 'fieldProvenance',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CourseSectionScalarFieldEnum = (typeof CourseSectionScalarFieldEnum)[keyof typeof CourseSectionScalarFieldEnum]


export const SectionRosterScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sectionId: 'sectionId',
  participantIdentityId: 'participantIdentityId',
  entryDate: 'entryDate',
  exitDate: 'exitDate',
  entryTypeDescriptor: 'entryTypeDescriptor',
  exitTypeDescriptor: 'exitTypeDescriptor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SectionRosterScalarFieldEnum = (typeof SectionRosterScalarFieldEnum)[keyof typeof SectionRosterScalarFieldEnum]


export const StudentAcademicRecordGradeScalarFieldEnum = {
  id: 'id',
  personId: 'personId',
  courseId: 'courseId',
  termId: 'termId',
  sectionId: 'sectionId',
  gradeState: 'gradeState',
  asOfDate: 'asOfDate',
  letterGrade: 'letterGrade',
  percentGrade: 'percentGrade',
  gradeTypeDescriptor: 'gradeTypeDescriptor',
  gradingPeriodDescriptor: 'gradingPeriodDescriptor',
  externalId: 'externalId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StudentAcademicRecordGradeScalarFieldEnum = (typeof StudentAcademicRecordGradeScalarFieldEnum)[keyof typeof StudentAcademicRecordGradeScalarFieldEnum]


export const CalendarEventScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  source: 'source',
  externalId: 'externalId',
  recurringEventId: 'recurringEventId',
  iCalUid: 'iCalUid',
  ownerParticipantId: 'ownerParticipantId',
  title: 'title',
  description: 'description',
  location: 'location',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  isAllDay: 'isAllDay',
  timezone: 'timezone',
  visibility: 'visibility',
  status: 'status',
  googleEventType: 'googleEventType',
  hiddenByOwnerAt: 'hiddenByOwnerAt',
  conferenceUrl: 'conferenceUrl',
  conferenceProvider: 'conferenceProvider',
  conferencePhone: 'conferencePhone',
  htmlLink: 'htmlLink',
  ingestedAt: 'ingestedAt',
  lastSyncedAt: 'lastSyncedAt',
  etag: 'etag',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rawAttendees: 'rawAttendees',
  organizerEmail: 'organizerEmail',
  originalStartsAt: 'originalStartsAt',
  matchedMeetingOccurrenceId: 'matchedMeetingOccurrenceId',
  matchedPracticeId: 'matchedPracticeId',
  matchConfidence: 'matchConfidence',
  matchedAt: 'matchedAt'
} as const

export type CalendarEventScalarFieldEnum = (typeof CalendarEventScalarFieldEnum)[keyof typeof CalendarEventScalarFieldEnum]


export const CalendarEventAttendeeScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  eventId: 'eventId',
  participantId: 'participantId',
  responseStatus: 'responseStatus',
  isOptional: 'isOptional',
  isOrganizer: 'isOrganizer',
  rawEmail: 'rawEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CalendarEventAttendeeScalarFieldEnum = (typeof CalendarEventAttendeeScalarFieldEnum)[keyof typeof CalendarEventAttendeeScalarFieldEnum]


export const CalendarEventContributionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  eventId: 'eventId',
  participantId: 'participantId',
  calendarId: 'calendarId',
  externalId: 'externalId',
  credentialKind: 'credentialKind',
  etag: 'etag',
  lastSeenAt: 'lastSeenAt',
  createdAt: 'createdAt'
} as const

export type CalendarEventContributionScalarFieldEnum = (typeof CalendarEventContributionScalarFieldEnum)[keyof typeof CalendarEventContributionScalarFieldEnum]


export const CalendarSyncStateScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  participantId: 'participantId',
  calendarId: 'calendarId',
  syncToken: 'syncToken',
  lastSyncedAt: 'lastSyncedAt',
  lastManualResyncAt: 'lastManualResyncAt',
  lastError: 'lastError',
  errorCount: 'errorCount',
  verifiedMailbox: 'verifiedMailbox',
  staleAliasSkipCount: 'staleAliasSkipCount',
  credentialKind: 'credentialKind',
  personConnectionId: 'personConnectionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CalendarSyncStateScalarFieldEnum = (typeof CalendarSyncStateScalarFieldEnum)[keyof typeof CalendarSyncStateScalarFieldEnum]


export const CalendarWatchChannelScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  participantId: 'participantId',
  calendarId: 'calendarId',
  channelId: 'channelId',
  resourceId: 'resourceId',
  verificationToken: 'verificationToken',
  expiration: 'expiration',
  lastWebhookSyncAt: 'lastWebhookSyncAt',
  credentialKind: 'credentialKind',
  personConnectionId: 'personConnectionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CalendarWatchChannelScalarFieldEnum = (typeof CalendarWatchChannelScalarFieldEnum)[keyof typeof CalendarWatchChannelScalarFieldEnum]


export const CalendarSelectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  participantId: 'participantId',
  calendarId: 'calendarId',
  summary: 'summary',
  selected: 'selected',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CalendarSelectionScalarFieldEnum = (typeof CalendarSelectionScalarFieldEnum)[keyof typeof CalendarSelectionScalarFieldEnum]


export const BoardScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  type: 'type',
  isPublic: 'isPublic',
  ownerScope: 'ownerScope',
  manualOrder: 'manualOrder',
  settings: 'settings',
  creatorId: 'creatorId',
  orgId: 'orgId',
  aorId: 'aorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type BoardScalarFieldEnum = (typeof BoardScalarFieldEnum)[keyof typeof BoardScalarFieldEnum]


export const BoardWidgetScalarFieldEnum = {
  id: 'id',
  boardId: 'boardId',
  widgetId: 'widgetId',
  displayOrder: 'displayOrder',
  columnCount: 'columnCount',
  settings: 'settings',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BoardWidgetScalarFieldEnum = (typeof BoardWidgetScalarFieldEnum)[keyof typeof BoardWidgetScalarFieldEnum]


export const BoardColumnScalarFieldEnum = {
  id: 'id',
  boardId: 'boardId',
  title: 'title',
  entityType: 'entityType',
  filterLevel: 'filterLevel',
  filterParentEntityType: 'filterParentEntityType',
  filterParentId: 'filterParentId',
  filterParentSource: 'filterParentSource',
  filterStates: 'filterStates',
  filterRelations: 'filterRelations',
  manualOrder: 'manualOrder',
  categoryId: 'categoryId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BoardColumnScalarFieldEnum = (typeof BoardColumnScalarFieldEnum)[keyof typeof BoardColumnScalarFieldEnum]


export const TagGroupScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  name: 'name',
  singleSelect: 'singleSelect',
  color: 'color',
  displayOrder: 'displayOrder',
  retiredAt: 'retiredAt',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TagGroupScalarFieldEnum = (typeof TagGroupScalarFieldEnum)[keyof typeof TagGroupScalarFieldEnum]


export const TagScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  name: 'name',
  color: 'color',
  tagGroupId: 'tagGroupId',
  retiredAt: 'retiredAt',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TagScalarFieldEnum = (typeof TagScalarFieldEnum)[keyof typeof TagScalarFieldEnum]


export const PulseConversationDraftItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conversationId: 'conversationId',
  workItemId: 'workItemId',
  capturedFields: 'capturedFields',
  passed: 'passed',
  synthesisSnapshot: 'synthesisSnapshot',
  directives: 'directives',
  orgId: 'orgId'
} as const

export type PulseConversationDraftItemScalarFieldEnum = (typeof PulseConversationDraftItemScalarFieldEnum)[keyof typeof PulseConversationDraftItemScalarFieldEnum]


export const TagAssignmentScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  tagId: 'tagId',
  projectId: 'projectId',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TagAssignmentScalarFieldEnum = (typeof TagAssignmentScalarFieldEnum)[keyof typeof TagAssignmentScalarFieldEnum]


export const PriorityScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  horizon: 'horizon',
  state: 'state',
  kind: 'kind',
  progressMode: 'progressMode',
  audience: 'audience',
  rating: 'rating',
  impactScore: 'impactScore',
  embeddingModel: 'embeddingModel',
  embeddingContentHash: 'embeddingContentHash',
  embeddedAt: 'embeddedAt',
  createdById: 'createdById',
  orgId: 'orgId',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  planId: 'planId',
  planNodeKind: 'planNodeKind',
  anchorRole: 'anchorRole',
  anchorLabel: 'anchorLabel'
} as const

export type PriorityScalarFieldEnum = (typeof PriorityScalarFieldEnum)[keyof typeof PriorityScalarFieldEnum]


export const ValueProfileScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  priorityId: 'priorityId',
  slug: 'slug',
  redCriteria: 'redCriteria',
  yellowCriteria: 'yellowCriteria',
  greenCriteria: 'greenCriteria',
  blueCriteria: 'blueCriteria',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ValueProfileScalarFieldEnum = (typeof ValueProfileScalarFieldEnum)[keyof typeof ValueProfileScalarFieldEnum]


export const PracticeProfileScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  priorityId: 'priorityId',
  intakeKind: 'intakeKind',
  intakeTemplateId: 'intakeTemplateId',
  intakeUrl: 'intakeUrl',
  intakeLabel: 'intakeLabel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PracticeProfileScalarFieldEnum = (typeof PracticeProfileScalarFieldEnum)[keyof typeof PracticeProfileScalarFieldEnum]


export const MeasureProfileScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  priorityId: 'priorityId',
  sourceUrl: 'sourceUrl',
  direction: 'direction',
  unit: 'unit',
  precision: 'precision',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeasureProfileScalarFieldEnum = (typeof MeasureProfileScalarFieldEnum)[keyof typeof MeasureProfileScalarFieldEnum]


export const MeasureReadingScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  evidenceId: 'evidenceId',
  measureId: 'measureId',
  value: 'value',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MeasureReadingScalarFieldEnum = (typeof MeasureReadingScalarFieldEnum)[keyof typeof MeasureReadingScalarFieldEnum]


export const GovernsScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  priorityId: 'priorityId',
  scopeKind: 'scopeKind',
  unitId: 'unitId',
  targetPriorityId: 'targetPriorityId',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GovernsScalarFieldEnum = (typeof GovernsScalarFieldEnum)[keyof typeof GovernsScalarFieldEnum]


export const IndicatesScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  measureId: 'measureId',
  priorityId: 'priorityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type IndicatesScalarFieldEnum = (typeof IndicatesScalarFieldEnum)[keyof typeof IndicatesScalarFieldEnum]


export const OutcomeTargetScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  outcomeId: 'outcomeId',
  priorityId: 'priorityId',
  measureId: 'measureId',
  comparator: 'comparator',
  value: 'value',
  baselineMode: 'baselineMode',
  baselineValue: 'baselineValue',
  evaluateAt: 'evaluateAt',
  atRiskTolerance: 'atRiskTolerance',
  exceedsValue: 'exceedsValue',
  origin: 'origin',
  periodEnd: 'periodEnd',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OutcomeTargetScalarFieldEnum = (typeof OutcomeTargetScalarFieldEnum)[keyof typeof OutcomeTargetScalarFieldEnum]


export const WatchesScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  watcherPriorityId: 'watcherPriorityId',
  priorityId: 'priorityId',
  createdAt: 'createdAt'
} as const

export type WatchesScalarFieldEnum = (typeof WatchesScalarFieldEnum)[keyof typeof WatchesScalarFieldEnum]


export const ReviewsScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  practiceId: 'practiceId',
  principleId: 'principleId',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReviewsScalarFieldEnum = (typeof ReviewsScalarFieldEnum)[keyof typeof ReviewsScalarFieldEnum]


export const AgendaItemScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  pulseId: 'pulseId',
  sectionId: 'sectionId',
  priorityId: 'priorityId',
  beliefId: 'beliefId',
  measurePriorityId: 'measurePriorityId',
  band: 'band',
  rank: 'rank',
  disposition: 'disposition',
  escalatedToPriorityId: 'escalatedToPriorityId',
  escalatedToUnitId: 'escalatedToUnitId',
  escalatedById: 'escalatedById',
  routedFromPulseId: 'routedFromPulseId',
  groupKey: 'groupKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgendaItemScalarFieldEnum = (typeof AgendaItemScalarFieldEnum)[keyof typeof AgendaItemScalarFieldEnum]


export const AgendaVoteScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  agendaItemId: 'agendaItemId',
  personId: 'personId',
  count: 'count',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgendaVoteScalarFieldEnum = (typeof AgendaVoteScalarFieldEnum)[keyof typeof AgendaVoteScalarFieldEnum]


export const RatingRoundScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  title: 'title',
  mode: 'mode',
  focusRanking: 'focusRanking',
  focusCount: 'focusCount',
  state: 'state',
  opensAt: 'opensAt',
  dueAt: 'dueAt',
  revealedAt: 'revealedAt',
  finalizedAt: 'finalizedAt',
  facilitatorId: 'facilitatorId',
  occurrenceId: 'occurrenceId',
  practiceId: 'practiceId',
  pulseId: 'pulseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RatingRoundScalarFieldEnum = (typeof RatingRoundScalarFieldEnum)[keyof typeof RatingRoundScalarFieldEnum]


export const RatingRoundItemScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  roundId: 'roundId',
  priorityId: 'priorityId',
  position: 'position',
  focusRank: 'focusRank',
  isFocus: 'isFocus',
  suggestedRating: 'suggestedRating',
  differenceSummary: 'differenceSummary',
  suggestedNote: 'suggestedNote',
  officialRating: 'officialRating',
  officialNote: 'officialNote',
  officialBeliefId: 'officialBeliefId',
  finalizedAt: 'finalizedAt',
  finalizedById: 'finalizedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RatingRoundItemScalarFieldEnum = (typeof RatingRoundItemScalarFieldEnum)[keyof typeof RatingRoundItemScalarFieldEnum]


export const RatingRoundRaterScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  roundId: 'roundId',
  personId: 'personId',
  submittedAt: 'submittedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RatingRoundRaterScalarFieldEnum = (typeof RatingRoundRaterScalarFieldEnum)[keyof typeof RatingRoundRaterScalarFieldEnum]


export const RatingSubmissionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  roundId: 'roundId',
  itemId: 'itemId',
  raterPersonId: 'raterPersonId',
  rating: 'rating',
  note: 'note',
  rank: 'rank',
  submittedAt: 'submittedAt',
  updatedAt: 'updatedAt'
} as const

export type RatingSubmissionScalarFieldEnum = (typeof RatingSubmissionScalarFieldEnum)[keyof typeof RatingSubmissionScalarFieldEnum]


export const BeliefAuthorScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  beliefId: 'beliefId',
  personId: 'personId',
  createdAt: 'createdAt'
} as const

export type BeliefAuthorScalarFieldEnum = (typeof BeliefAuthorScalarFieldEnum)[keyof typeof BeliefAuthorScalarFieldEnum]


export const RollupScheduleScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  targetType: 'targetType',
  targetId: 'targetId',
  cadence: 'cadence',
  anchorDay: 'anchorDay',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RollupScheduleScalarFieldEnum = (typeof RollupScheduleScalarFieldEnum)[keyof typeof RollupScheduleScalarFieldEnum]


export const ExampleContentApplicationScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  setKey: 'setKey',
  recipientPersonId: 'recipientPersonId',
  appliedByPersonId: 'appliedByPersonId',
  appliedAt: 'appliedAt',
  removedAt: 'removedAt'
} as const

export type ExampleContentApplicationScalarFieldEnum = (typeof ExampleContentApplicationScalarFieldEnum)[keyof typeof ExampleContentApplicationScalarFieldEnum]


export const SavedViewScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  name: 'name',
  spec: 'spec',
  ownerId: 'ownerId',
  isShared: 'isShared',
  position: 'position',
  seedKey: 'seedKey',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SavedViewScalarFieldEnum = (typeof SavedViewScalarFieldEnum)[keyof typeof SavedViewScalarFieldEnum]


export const ViewItemOrderScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  viewId: 'viewId',
  priorityId: 'priorityId',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ViewItemOrderScalarFieldEnum = (typeof ViewItemOrderScalarFieldEnum)[keyof typeof ViewItemOrderScalarFieldEnum]


export const PulseRequestScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  createdById: 'createdById',
  title: 'title',
  brief: 'brief',
  templateId: 'templateId',
  templateVersion: 'templateVersion',
  audience: 'audience',
  destination: 'destination',
  practiceId: 'practiceId',
  intakePracticeId: 'intakePracticeId',
  scheduleRecurrence: 'scheduleRecurrence',
  scheduleDay: 'scheduleDay',
  scheduleTime: 'scheduleTime',
  scheduleTimezone: 'scheduleTimezone',
  scheduleStartDate: 'scheduleStartDate',
  scheduleEndDate: 'scheduleEndDate',
  scheduleInterval: 'scheduleInterval',
  scheduleMonth: 'scheduleMonth',
  schedulePausedAt: 'schedulePausedAt',
  nextSendAt: 'nextSendAt',
  promotionHintDismissedAt: 'promotionHintDismissedAt',
  recordApproverPersonId: 'recordApproverPersonId',
  visibilityPolicy: 'visibilityPolicy',
  sendSettings: 'sendSettings',
  responseReaders: 'responseReaders',
  responseReaderUnitId: 'responseReaderUnitId',
  responseReaderPriorityId: 'responseReaderPriorityId',
  orgRole: 'orgRole',
  practiceKind: 'practiceKind',
  rollupScope: 'rollupScope',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  layerOrdinalSeq: 'layerOrdinalSeq'
} as const

export type PulseRequestScalarFieldEnum = (typeof PulseRequestScalarFieldEnum)[keyof typeof PulseRequestScalarFieldEnum]


export const PulseRequestLayerScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  requestId: 'requestId',
  unitId: 'unitId',
  additions: 'additions',
  templateId: 'templateId',
  ordinal: 'ordinal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PulseRequestLayerScalarFieldEnum = (typeof PulseRequestLayerScalarFieldEnum)[keyof typeof PulseRequestLayerScalarFieldEnum]


export const PulseRequestSendScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  requestId: 'requestId',
  sentById: 'sentById',
  sentAt: 'sentAt',
  closesAt: 'closesAt',
  title: 'title',
  brief: 'brief',
  templateId: 'templateId',
  templateVersion: 'templateVersion',
  remindersEnabled: 'remindersEnabled',
  reminderEveryDays: 'reminderEveryDays',
  reminderMax: 'reminderMax',
  opensAt: 'opensAt',
  notifyOnOpen: 'notifyOnOpen',
  reminderMode: 'reminderMode',
  reminderTimes: 'reminderTimes',
  reminderTimezone: 'reminderTimezone',
  status: 'status',
  rollupNoteId: 'rollupNoteId',
  rollupScope: 'rollupScope',
  occurrenceAt: 'occurrenceAt',
  responseReaders: 'responseReaders',
  responseReaderUnitId: 'responseReaderUnitId',
  responseReaderPriorityId: 'responseReaderPriorityId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  visibilityPolicy: 'visibilityPolicy',
  visibilityMode: 'visibilityMode',
  visibilityPolicyEvents: 'visibilityPolicyEvents'
} as const

export type PulseRequestSendScalarFieldEnum = (typeof PulseRequestSendScalarFieldEnum)[keyof typeof PulseRequestSendScalarFieldEnum]


export const PulseRequestSendRollupScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sendId: 'sendId',
  kind: 'kind',
  scopePersonId: 'scopePersonId',
  noteId: 'noteId',
  createdAt: 'createdAt'
} as const

export type PulseRequestSendRollupScalarFieldEnum = (typeof PulseRequestSendRollupScalarFieldEnum)[keyof typeof PulseRequestSendRollupScalarFieldEnum]


export const PulseRequestRecipientScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sendId: 'sendId',
  personId: 'personId',
  subjectPersonId: 'subjectPersonId',
  party: 'party',
  status: 'status',
  pulseId: 'pulseId',
  noteId: 'noteId',
  declineReason: 'declineReason',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  declinedAt: 'declinedAt',
  lastRemindedAt: 'lastRemindedAt',
  reminderCount: 'reminderCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PulseRequestRecipientScalarFieldEnum = (typeof PulseRequestRecipientScalarFieldEnum)[keyof typeof PulseRequestRecipientScalarFieldEnum]


export const PracticeRecordScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sendId: 'sendId',
  subjectPersonId: 'subjectPersonId',
  ownerPersonId: 'ownerPersonId',
  approverPersonId: 'approverPersonId',
  standing: 'standing',
  noteId: 'noteId',
  responseId: 'responseId',
  state: 'state',
  version: 'version',
  approvedVersion: 'approvedVersion',
  approvedAt: 'approvedAt',
  finalisedAt: 'finalisedAt',
  sharedAt: 'sharedAt',
  signedAt: 'signedAt',
  shareHeldAt: 'shareHeldAt',
  importedFrom: 'importedFrom',
  legacySnapshot: 'legacySnapshot',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PracticeRecordScalarFieldEnum = (typeof PracticeRecordScalarFieldEnum)[keyof typeof PracticeRecordScalarFieldEnum]


export const PracticeRecordRevisionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordId: 'recordId',
  version: 'version',
  kind: 'kind',
  authorPersonId: 'authorPersonId',
  impersonatedById: 'impersonatedById',
  reason: 'reason',
  fromState: 'fromState',
  toState: 'toState',
  changes: 'changes',
  redactions: 'redactions',
  createdAt: 'createdAt'
} as const

export type PracticeRecordRevisionScalarFieldEnum = (typeof PracticeRecordRevisionScalarFieldEnum)[keyof typeof PracticeRecordRevisionScalarFieldEnum]


export const PracticeRecordSignatureScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordId: 'recordId',
  version: 'version',
  signerPersonId: 'signerPersonId',
  party: 'party',
  kind: 'kind',
  signedAt: 'signedAt',
  attestedById: 'attestedById',
  impersonatedById: 'impersonatedById',
  comment: 'comment',
  reason: 'reason'
} as const

export type PracticeRecordSignatureScalarFieldEnum = (typeof PracticeRecordSignatureScalarFieldEnum)[keyof typeof PracticeRecordSignatureScalarFieldEnum]


export const PracticeRunSynthesisScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  sendId: 'sendId',
  subjectPersonId: 'subjectPersonId',
  audienceKey: 'audienceKey',
  basedOn: 'basedOn',
  content: 'content',
  model: 'model',
  generatedById: 'generatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PracticeRunSynthesisScalarFieldEnum = (typeof PracticeRunSynthesisScalarFieldEnum)[keyof typeof PracticeRunSynthesisScalarFieldEnum]


export const PracticeAssignmentScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  practiceId: 'practiceId',
  reviewerPersonId: 'reviewerPersonId',
  party: 'party',
  standing: 'standing',
  subjectRule: 'subjectRule',
  subjectPersonIds: 'subjectPersonIds',
  subjectUnitId: 'subjectUnitId',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  createdById: 'createdById',
  events: 'events',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PracticeAssignmentScalarFieldEnum = (typeof PracticeAssignmentScalarFieldEnum)[keyof typeof PracticeAssignmentScalarFieldEnum]


export const EvidenceScalarFieldEnum = {
  id: 'id',
  occurredAt: 'occurredAt',
  kind: 'kind',
  sourceExcerpt: 'sourceExcerpt',
  source: 'source',
  personId: 'personId',
  subjectType: 'subjectType',
  createdById: 'createdById',
  pulseId: 'pulseId',
  orgId: 'orgId',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dismissedAt: 'dismissedAt',
  dismissedReason: 'dismissedReason',
  dueText: 'dueText',
  ownerText: 'ownerText',
  commitmentLevel: 'commitmentLevel',
  excerptVerification: 'excerptVerification',
  excerptVerifiedAt: 'excerptVerifiedAt',
  sensitivityLevel: 'sensitivityLevel',
  dataCategory: 'dataCategory',
  embeddingModel: 'embeddingModel',
  embeddingContentHash: 'embeddingContentHash',
  embeddedAt: 'embeddedAt',
  sourceUrls: 'sourceUrls',
  commentId: 'commentId',
  meetingSectionId: 'meetingSectionId',
  excerptEditedAt: 'excerptEditedAt'
} as const

export type EvidenceScalarFieldEnum = (typeof EvidenceScalarFieldEnum)[keyof typeof EvidenceScalarFieldEnum]


export const EvidenceCitationScalarFieldEnum = {
  evidenceId: 'evidenceId',
  url: 'url',
  orgId: 'orgId'
} as const

export type EvidenceCitationScalarFieldEnum = (typeof EvidenceCitationScalarFieldEnum)[keyof typeof EvidenceCitationScalarFieldEnum]


export const BeliefScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  subjectType: 'subjectType',
  createdById: 'createdById',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  rating: 'rating',
  rationale: 'rationale',
  statement: 'statement',
  sentiment: 'sentiment',
  confidence: 'confidence',
  completion: 'completion',
  deciderId: 'deciderId',
  parkedUntil: 'parkedUntil',
  basis: 'basis',
  validFrom: 'validFrom',
  invalidatedAt: 'invalidatedAt',
  confidenceComputedAt: 'confidenceComputedAt',
  confidenceFloor: 'confidenceFloor',
  statementEmbeddingModel: 'statementEmbeddingModel',
  statementContentHash: 'statementContentHash',
  statementEmbeddedAt: 'statementEmbeddedAt'
} as const

export type BeliefScalarFieldEnum = (typeof BeliefScalarFieldEnum)[keyof typeof BeliefScalarFieldEnum]


export const PulseScalarFieldEnum = {
  id: 'id',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  kind: 'kind',
  orgId: 'orgId',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  researchStrategy: 'researchStrategy',
  researchSeedJson: 'researchSeedJson',
  slowPassProcessedAt: 'slowPassProcessedAt',
  pulseRequestSendId: 'pulseRequestSendId',
  practiceId: 'practiceId'
} as const

export type PulseScalarFieldEnum = (typeof PulseScalarFieldEnum)[keyof typeof PulseScalarFieldEnum]


export const PrioritySupportScalarFieldEnum = {
  id: 'id',
  fromPriorityId: 'fromPriorityId',
  toPriorityId: 'toPriorityId',
  orgId: 'orgId',
  runId: 'runId',
  position: 'position',
  status: 'status',
  inferredContribution: 'inferredContribution',
  contributionRationale: 'contributionRationale',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PrioritySupportScalarFieldEnum = (typeof PrioritySupportScalarFieldEnum)[keyof typeof PrioritySupportScalarFieldEnum]


export const BeliefEvidenceScalarFieldEnum = {
  id: 'id',
  beliefId: 'beliefId',
  evidenceId: 'evidenceId',
  orgId: 'orgId',
  stance: 'stance',
  linkOrigin: 'linkOrigin',
  consolidationRunId: 'consolidationRunId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BeliefEvidenceScalarFieldEnum = (typeof BeliefEvidenceScalarFieldEnum)[keyof typeof BeliefEvidenceScalarFieldEnum]


export const GraphConsolidationRunScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  orgLocalDate: 'orgLocalDate',
  status: 'status',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt',
  haltReason: 'haltReason',
  stats: 'stats',
  llmInputTokens: 'llmInputTokens',
  llmOutputTokens: 'llmOutputTokens',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GraphConsolidationRunScalarFieldEnum = (typeof GraphConsolidationRunScalarFieldEnum)[keyof typeof GraphConsolidationRunScalarFieldEnum]


export const EvidenceClassificationChangeScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  evidenceId: 'evidenceId',
  fromLevel: 'fromLevel',
  toLevel: 'toLevel',
  fromCategory: 'fromCategory',
  toCategory: 'toCategory',
  actorId: 'actorId',
  origin: 'origin',
  status: 'status',
  reason: 'reason',
  decidedById: 'decidedById',
  decidedAt: 'decidedAt',
  decisionReason: 'decisionReason',
  createdAt: 'createdAt'
} as const

export type EvidenceClassificationChangeScalarFieldEnum = (typeof EvidenceClassificationChangeScalarFieldEnum)[keyof typeof EvidenceClassificationChangeScalarFieldEnum]


export const OrgClassificationDefaultScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  categoryId: 'categoryId',
  level: 'level',
  updatedById: 'updatedById',
  reason: 'reason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrgClassificationDefaultScalarFieldEnum = (typeof OrgClassificationDefaultScalarFieldEnum)[keyof typeof OrgClassificationDefaultScalarFieldEnum]


export const OrgClassificationDefaultChangeScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  categoryId: 'categoryId',
  fromLevel: 'fromLevel',
  toLevel: 'toLevel',
  actorId: 'actorId',
  reason: 'reason',
  createdAt: 'createdAt'
} as const

export type OrgClassificationDefaultChangeScalarFieldEnum = (typeof OrgClassificationDefaultChangeScalarFieldEnum)[keyof typeof OrgClassificationDefaultChangeScalarFieldEnum]


export const GraphConsolidationChangeScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  runId: 'runId',
  kind: 'kind',
  beliefId: 'beliefId',
  evidenceId: 'evidenceId',
  beliefEvidenceId: 'beliefEvidenceId',
  before: 'before',
  after: 'after',
  revertedAt: 'revertedAt',
  revertedById: 'revertedById',
  revertOfChangeId: 'revertOfChangeId',
  createdAt: 'createdAt'
} as const

export type GraphConsolidationChangeScalarFieldEnum = (typeof GraphConsolidationChangeScalarFieldEnum)[keyof typeof GraphConsolidationChangeScalarFieldEnum]


export const BeliefClaimEdgeScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  beliefAId: 'beliefAId',
  beliefBId: 'beliefBId',
  verdict: 'verdict',
  runId: 'runId',
  statementHashA: 'statementHashA',
  statementHashB: 'statementHashB',
  revertedAt: 'revertedAt',
  revertedById: 'revertedById',
  createdAt: 'createdAt'
} as const

export type BeliefClaimEdgeScalarFieldEnum = (typeof BeliefClaimEdgeScalarFieldEnum)[keyof typeof BeliefClaimEdgeScalarFieldEnum]


export const BeliefResolutionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  questionId: 'questionId',
  decisionId: 'decisionId',
  createdAt: 'createdAt'
} as const

export type BeliefResolutionScalarFieldEnum = (typeof BeliefResolutionScalarFieldEnum)[keyof typeof BeliefResolutionScalarFieldEnum]


export const BeliefLinkScalarFieldEnum = {
  id: 'id',
  valence: 'valence',
  relation: 'relation',
  beliefId: 'beliefId',
  priorityId: 'priorityId',
  orgId: 'orgId',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type BeliefLinkScalarFieldEnum = (typeof BeliefLinkScalarFieldEnum)[keyof typeof BeliefLinkScalarFieldEnum]


export const PulseParticipantScalarFieldEnum = {
  id: 'id',
  pulseId: 'pulseId',
  personId: 'personId',
  role: 'role',
  orgId: 'orgId',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PulseParticipantScalarFieldEnum = (typeof PulseParticipantScalarFieldEnum)[keyof typeof PulseParticipantScalarFieldEnum]


export const PriorityOrgUnitScalarFieldEnum = {
  id: 'id',
  priorityId: 'priorityId',
  unitId: 'unitId',
  orgId: 'orgId',
  position: 'position',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PriorityOrgUnitScalarFieldEnum = (typeof PriorityOrgUnitScalarFieldEnum)[keyof typeof PriorityOrgUnitScalarFieldEnum]


export const PersonRelationshipScalarFieldEnum = {
  id: 'id',
  type: 'type',
  fromPersonId: 'fromPersonId',
  toPersonId: 'toPersonId',
  source: 'source',
  validFrom: 'validFrom',
  validTo: 'validTo',
  orgId: 'orgId',
  runId: 'runId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PersonRelationshipScalarFieldEnum = (typeof PersonRelationshipScalarFieldEnum)[keyof typeof PersonRelationshipScalarFieldEnum]


export const SimulationRunScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  runId: 'runId',
  archetypeId: 'archetypeId',
  arcShapeId: 'arcShapeId',
  schemaVersion: 'schemaVersion',
  rowsWritten: 'rowsWritten',
  generatorVersion: 'generatorVersion',
  droppedSlots: 'droppedSlots',
  sweepOwnerToken: 'sweepOwnerToken',
  sweepLockedAt: 'sweepLockedAt',
  createdAt: 'createdAt'
} as const

export type SimulationRunScalarFieldEnum = (typeof SimulationRunScalarFieldEnum)[keyof typeof SimulationRunScalarFieldEnum]


export const SimulationPeriodScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  runId: 'runId',
  periodIndex: 'periodIndex',
  asOf: 'asOf',
  rowsWritten: 'rowsWritten',
  generatorVersion: 'generatorVersion',
  createdAt: 'createdAt'
} as const

export type SimulationPeriodScalarFieldEnum = (typeof SimulationPeriodScalarFieldEnum)[keyof typeof SimulationPeriodScalarFieldEnum]


export const PriorityPlanMembershipScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  priorityId: 'priorityId',
  planId: 'planId',
  nodeKind: 'nodeKind',
  createdAt: 'createdAt'
} as const

export type PriorityPlanMembershipScalarFieldEnum = (typeof PriorityPlanMembershipScalarFieldEnum)[keyof typeof PriorityPlanMembershipScalarFieldEnum]


export const PriorityAssignmentScalarFieldEnum = {
  id: 'id',
  priorityId: 'priorityId',
  personId: 'personId',
  role: 'role',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PriorityAssignmentScalarFieldEnum = (typeof PriorityAssignmentScalarFieldEnum)[keyof typeof PriorityAssignmentScalarFieldEnum]


export const PriorityExtractedItemScalarFieldEnum = {
  id: 'id',
  priorityId: 'priorityId',
  extractedItemId: 'extractedItemId',
  orgId: 'orgId',
  createdAt: 'createdAt'
} as const

export type PriorityExtractedItemScalarFieldEnum = (typeof PriorityExtractedItemScalarFieldEnum)[keyof typeof PriorityExtractedItemScalarFieldEnum]


export const PriorityEvidenceScalarFieldEnum = {
  id: 'id',
  priorityId: 'priorityId',
  evidenceId: 'evidenceId',
  orgId: 'orgId',
  createdAt: 'createdAt'
} as const

export type PriorityEvidenceScalarFieldEnum = (typeof PriorityEvidenceScalarFieldEnum)[keyof typeof PriorityEvidenceScalarFieldEnum]


export const LegacyBridgeScalarFieldEnum = {
  id: 'id',
  sourceTable: 'sourceTable',
  sourceId: 'sourceId',
  priorityId: 'priorityId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LegacyBridgeScalarFieldEnum = (typeof LegacyBridgeScalarFieldEnum)[keyof typeof LegacyBridgeScalarFieldEnum]


export const LegacyEntityRedirectScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  legacyTable: 'legacyTable',
  legacyId: 'legacyId',
  priorityId: 'priorityId',
  createdAt: 'createdAt'
} as const

export type LegacyEntityRedirectScalarFieldEnum = (typeof LegacyEntityRedirectScalarFieldEnum)[keyof typeof LegacyEntityRedirectScalarFieldEnum]


export const PriorityDependencyScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  blockingPriorityId: 'blockingPriorityId',
  blockedPriorityId: 'blockedPriorityId',
  createdAt: 'createdAt',
  createdById: 'createdById'
} as const

export type PriorityDependencyScalarFieldEnum = (typeof PriorityDependencyScalarFieldEnum)[keyof typeof PriorityDependencyScalarFieldEnum]


export const PriorityScoreScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  priorityId: 'priorityId',
  alignment: 'alignment',
  aifeImpact: 'aifeImpact',
  effort: 'effort',
  leverageScore: 'leverageScore',
  formulaVersion: 'formulaVersion',
  scorer: 'scorer',
  scoredAt: 'scoredAt',
  isOverridden: 'isOverridden',
  overrideJustification: 'overrideJustification',
  rationale: 'rationale',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PriorityScoreScalarFieldEnum = (typeof PriorityScoreScalarFieldEnum)[keyof typeof PriorityScoreScalarFieldEnum]


export const ContextResearchRunScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  subjectName: 'subjectName',
  subjectUrl: 'subjectUrl',
  configJson: 'configJson',
  status: 'status',
  composedBundle: 'composedBundle',
  openingLine: 'openingLine',
  factsJson: 'factsJson',
  resolvedSubjectUrl: 'resolvedSubjectUrl',
  resolvedNcesLeaId: 'resolvedNcesLeaId',
  resolvedIdentityJson: 'resolvedIdentityJson',
  error: 'error',
  createdByPersonId: 'createdByPersonId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unitId: 'unitId',
  rosterReviewTaskId: 'rosterReviewTaskId'
} as const

export type ContextResearchRunScalarFieldEnum = (typeof ContextResearchRunScalarFieldEnum)[keyof typeof ContextResearchRunScalarFieldEnum]


export const ContextResearchSectionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  runId: 'runId',
  sectionKind: 'sectionKind',
  status: 'status',
  summary: 'summary',
  highlights: 'highlights',
  sources: 'sources',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ContextResearchSectionScalarFieldEnum = (typeof ContextResearchSectionScalarFieldEnum)[keyof typeof ContextResearchSectionScalarFieldEnum]


export const RosterCandidateScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  runId: 'runId',
  sourceUrl: 'sourceUrl',
  externalId: 'externalId',
  candidateKey: 'candidateKey',
  name: 'name',
  title: 'title',
  department: 'department',
  email: 'email',
  photoUrl: 'photoUrl',
  status: 'status',
  reviewedById: 'reviewedById',
  reviewedAt: 'reviewedAt',
  reviewNote: 'reviewNote',
  promotedPersonId: 'promotedPersonId',
  promotedById: 'promotedById',
  promotedAt: 'promotedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RosterCandidateScalarFieldEnum = (typeof RosterCandidateScalarFieldEnum)[keyof typeof RosterCandidateScalarFieldEnum]


export const StrategicPlanScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  title: 'title',
  scope: 'scope',
  schoolKey: 'schoolKey',
  unitId: 'unitId',
  adoptedOn: 'adoptedOn',
  spanStart: 'spanStart',
  spanEnd: 'spanEnd',
  sourceUrl: 'sourceUrl',
  sourceKind: 'sourceKind',
  status: 'status',
  adoptedById: 'adoptedById',
  adoptedEnteredById: 'adoptedEnteredById',
  adoptedAt: 'adoptedAt',
  adoptedVia: 'adoptedVia',
  parentPlanId: 'parentPlanId',
  supersededById: 'supersededById',
  researchRunId: 'researchRunId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StrategicPlanScalarFieldEnum = (typeof StrategicPlanScalarFieldEnum)[keyof typeof StrategicPlanScalarFieldEnum]


export const StrategicPlanCandidateScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  runId: 'runId',
  sourceUrl: 'sourceUrl',
  sourceRef: 'sourceRef',
  candidateKey: 'candidateKey',
  parentCandidateId: 'parentCandidateId',
  nodeKind: 'nodeKind',
  title: 'title',
  statement: 'statement',
  metricsJson: 'metricsJson',
  focusTags: 'focusTags',
  status: 'status',
  promotedPriorityId: 'promotedPriorityId',
  promotedMeasureId: 'promotedMeasureId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StrategicPlanCandidateScalarFieldEnum = (typeof StrategicPlanCandidateScalarFieldEnum)[keyof typeof StrategicPlanCandidateScalarFieldEnum]


export const StrategicPlanNodeEditScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  planId: 'planId',
  priorityId: 'priorityId',
  statement: 'statement',
  focusTags: 'focusTags',
  sourceUrl: 'sourceUrl',
  editedFields: 'editedFields',
  editedById: 'editedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StrategicPlanNodeEditScalarFieldEnum = (typeof StrategicPlanNodeEditScalarFieldEnum)[keyof typeof StrategicPlanNodeEditScalarFieldEnum]


export const ContextSourceScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  linkAttachmentId: 'linkAttachmentId',
  name: 'name',
  role: 'role',
  significance: 'significance',
  isCanonical: 'isCanonical',
  verificationState: 'verificationState',
  lastVerifiedAt: 'lastVerifiedAt',
  publisher: 'publisher',
  issuedAt: 'issuedAt',
  validFrom: 'validFrom',
  validUntil: 'validUntil',
  jurisdiction: 'jurisdiction',
  supersedesId: 'supersedesId',
  createdById: 'createdById',
  unitId: 'unitId',
  pastedText: 'pastedText',
  externalKey: 'externalKey',
  textFormat: 'textFormat',
  maintainedAtUrl: 'maintainedAtUrl',
  tier: 'tier',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ContextSourceScalarFieldEnum = (typeof ContextSourceScalarFieldEnum)[keyof typeof ContextSourceScalarFieldEnum]


export const ContextSourceChunkScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  contextSourceId: 'contextSourceId',
  ordinal: 'ordinal',
  text: 'text',
  createdAt: 'createdAt'
} as const

export type ContextSourceChunkScalarFieldEnum = (typeof ContextSourceChunkScalarFieldEnum)[keyof typeof ContextSourceChunkScalarFieldEnum]


export const WelcomeLeaderScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  name: 'name',
  email: 'email',
  role: 'role',
  openingLine: 'openingLine',
  openingLineRunId: 'openingLineRunId',
  createdByPersonId: 'createdByPersonId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WelcomeLeaderScalarFieldEnum = (typeof WelcomeLeaderScalarFieldEnum)[keyof typeof WelcomeLeaderScalarFieldEnum]


export const ConversationArtifactScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  pulseId: 'pulseId',
  dataJson: 'dataJson',
  chosenTemplate: 'chosenTemplate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ConversationArtifactScalarFieldEnum = (typeof ConversationArtifactScalarFieldEnum)[keyof typeof ConversationArtifactScalarFieldEnum]


export const ActionBoardInterventionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  name: 'name',
  ownerName: 'ownerName',
  note: 'note',
  assignedById: 'assignedById',
  assignedAt: 'assignedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ActionBoardInterventionScalarFieldEnum = (typeof ActionBoardInterventionScalarFieldEnum)[keyof typeof ActionBoardInterventionScalarFieldEnum]


export const TodayFocusSteeringSignalScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  kind: 'kind',
  signal: 'signal',
  reason: 'reason',
  createdAt: 'createdAt',
  seq: 'seq'
} as const

export type TodayFocusSteeringSignalScalarFieldEnum = (typeof TodayFocusSteeringSignalScalarFieldEnum)[keyof typeof TodayFocusSteeringSignalScalarFieldEnum]


export const TodayFocusProfileSuppressionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  kind: 'kind',
  forgottenAt: 'forgottenAt',
  forgottenSeq: 'forgottenSeq',
  createdAt: 'createdAt'
} as const

export type TodayFocusProfileSuppressionScalarFieldEnum = (typeof TodayFocusProfileSuppressionScalarFieldEnum)[keyof typeof TodayFocusProfileSuppressionScalarFieldEnum]


export const SaiWeeklyRollupScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  windowStart: 'windowStart',
  windowEnd: 'windowEnd',
  weekStart: 'weekStart',
  sessions: 'sessions',
  activeClassrooms: 'activeClassrooms',
  totalClassrooms: 'totalClassrooms',
  studentConversations: 'studentConversations',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiWeeklyRollupScalarFieldEnum = (typeof SaiWeeklyRollupScalarFieldEnum)[keyof typeof SaiWeeklyRollupScalarFieldEnum]


export const SaiBreadthCellScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  windowStart: 'windowStart',
  windowEnd: 'windowEnd',
  weekStart: 'weekStart',
  gradeBand: 'gradeBand',
  subject: 'subject',
  sessions: 'sessions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiBreadthCellScalarFieldEnum = (typeof SaiBreadthCellScalarFieldEnum)[keyof typeof SaiBreadthCellScalarFieldEnum]


export const SaiSignalRollupScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  windowStart: 'windowStart',
  windowEnd: 'windowEnd',
  weekStart: 'weekStart',
  gradeBand: 'gradeBand',
  coveredSessions: 'coveredSessions',
  engaged: 'engaged',
  workingThrough: 'workingThrough',
  mayNeedGuidance: 'mayNeedGuidance',
  potentialConcern: 'potentialConcern',
  otherSignal: 'otherSignal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiSignalRollupScalarFieldEnum = (typeof SaiSignalRollupScalarFieldEnum)[keyof typeof SaiSignalRollupScalarFieldEnum]


export const SaiAlertRollupScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  windowStart: 'windowStart',
  windowEnd: 'windowEnd',
  weekStart: 'weekStart',
  theme: 'theme',
  suppressed: 'suppressed',
  total: 'total',
  unacknowledged: 'unacknowledged',
  oldestUnacknowledgedHours: 'oldestUnacknowledgedHours',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiAlertRollupScalarFieldEnum = (typeof SaiAlertRollupScalarFieldEnum)[keyof typeof SaiAlertRollupScalarFieldEnum]


export const SaiEducatorCohortRollupScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  windowStart: 'windowStart',
  windowEnd: 'windowEnd',
  weekStart: 'weekStart',
  cohort: 'cohort',
  gradeBand: 'gradeBand',
  educators: 'educators',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiEducatorCohortRollupScalarFieldEnum = (typeof SaiEducatorCohortRollupScalarFieldEnum)[keyof typeof SaiEducatorCohortRollupScalarFieldEnum]


export const SaiReportImportScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  fileKind: 'fileKind',
  externalOrgId: 'externalOrgId',
  generatedAt: 'generatedAt',
  timezone: 'timezone',
  reportRangeStart: 'reportRangeStart',
  reportRangeEnd: 'reportRangeEnd',
  bucket: 'bucket',
  fileName: 'fileName',
  rowCounts: 'rowCounts',
  groups: 'groups',
  importedById: 'importedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiReportImportScalarFieldEnum = (typeof SaiReportImportScalarFieldEnum)[keyof typeof SaiReportImportScalarFieldEnum]


export const SaiOrgMetricScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  importId: 'importId',
  family: 'family',
  groupLabel: 'groupLabel',
  groupOrder: 'groupOrder',
  metric: 'metric',
  grain: 'grain',
  periodStart: 'periodStart',
  surface: 'surface',
  category: 'category',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiOrgMetricScalarFieldEnum = (typeof SaiOrgMetricScalarFieldEnum)[keyof typeof SaiOrgMetricScalarFieldEnum]


export const SaiSchoolMetricScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  importId: 'importId',
  groupLabel: 'groupLabel',
  groupOrder: 'groupOrder',
  externalSchoolId: 'externalSchoolId',
  schoolName: 'schoolName',
  schoolKey: 'schoolKey',
  unitId: 'unitId',
  isExportOrg: 'isExportOrg',
  metric: 'metric',
  value: 'value',
  rank: 'rank',
  lastActiveAt: 'lastActiveAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiSchoolMetricScalarFieldEnum = (typeof SaiSchoolMetricScalarFieldEnum)[keyof typeof SaiSchoolMetricScalarFieldEnum]


export const SaiTeacherMetricScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  importId: 'importId',
  groupLabel: 'groupLabel',
  groupOrder: 'groupOrder',
  externalTeacherId: 'externalTeacherId',
  teacherName: 'teacherName',
  metric: 'metric',
  value: 'value',
  rank: 'rank',
  lastActiveAt: 'lastActiveAt',
  personId: 'personId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiTeacherMetricScalarFieldEnum = (typeof SaiTeacherMetricScalarFieldEnum)[keyof typeof SaiTeacherMetricScalarFieldEnum]


export const SaiCatalogUsageScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  importId: 'importId',
  groupLabel: 'groupLabel',
  groupOrder: 'groupOrder',
  kind: 'kind',
  externalId: 'externalId',
  name: 'name',
  detail: 'detail',
  rank: 'rank',
  usageCount: 'usageCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SaiCatalogUsageScalarFieldEnum = (typeof SaiCatalogUsageScalarFieldEnum)[keyof typeof SaiCatalogUsageScalarFieldEnum]


export const OrgUnitScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  kind: 'kind',
  structure: 'structure',
  sponsorUnitId: 'sponsorUnitId',
  endsOn: 'endsOn',
  name: 'name',
  unitKey: 'unitKey',
  url: 'url',
  description: 'description',
  handbookValuesShown: 'handbookValuesShown',
  parentUnitId: 'parentUnitId',
  externalIds: 'externalIds',
  isSelf: 'isSelf',
  source: 'source',
  researchRunId: 'researchRunId',
  retiredAt: 'retiredAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrgUnitScalarFieldEnum = (typeof OrgUnitScalarFieldEnum)[keyof typeof OrgUnitScalarFieldEnum]


export const SchoolProfileScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  unitId: 'unitId',
  level: 'level',
  gradeSpan: 'gradeSpan',
  enrollment: 'enrollment',
  designation: 'designation',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SchoolProfileScalarFieldEnum = (typeof SchoolProfileScalarFieldEnum)[keyof typeof SchoolProfileScalarFieldEnum]


export const UnitAssignmentScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  unitId: 'unitId',
  role: 'role',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  isHome: 'isHome',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UnitAssignmentScalarFieldEnum = (typeof UnitAssignmentScalarFieldEnum)[keyof typeof UnitAssignmentScalarFieldEnum]


export const ReportsToScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  personId: 'personId',
  managerId: 'managerId',
  dimension: 'dimension',
  authoritative: 'authoritative',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReportsToScalarFieldEnum = (typeof ReportsToScalarFieldEnum)[keyof typeof ReportsToScalarFieldEnum]


export const NoteScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  title: 'title',
  titleSetAt: 'titleSetAt',
  createdById: 'createdById',
  calendarEventId: 'calendarEventId',
  eventNoteScope: 'eventNoteScope',
  meetingId: 'meetingId',
  pulseId: 'pulseId',
  scheduledFor: 'scheduledFor',
  body: 'body',
  hasOwnContent: 'hasOwnContent',
  bodyUpdatedAt: 'bodyUpdatedAt',
  templateSuggestionDismissedAt: 'templateSuggestionDismissedAt',
  isPrivate: 'isPrivate',
  summaryAttemptCount: 'summaryAttemptCount',
  summaryClaimedAt: 'summaryClaimedAt',
  summaryCurrentAsOf: 'summaryCurrentAsOf',
  occurredAt: 'occurredAt',
  exampleContentApplicationId: 'exampleContentApplicationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NoteScalarFieldEnum = (typeof NoteScalarFieldEnum)[keyof typeof NoteScalarFieldEnum]


export const RecordingScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  createdById: 'createdById',
  viewingAsUserId: 'viewingAsUserId',
  mode: 'mode',
  status: 'status',
  mimeType: 'mimeType',
  durationMs: 'durationMs',
  storageKey: 'storageKey',
  consentAcknowledgedAt: 'consentAcknowledgedAt',
  sensitivityAcknowledgedAt: 'sensitivityAcknowledgedAt',
  captureSource: 'captureSource',
  liveSummaryLeaseToken: 'liveSummaryLeaseToken',
  liveSummaryLeaseUntil: 'liveSummaryLeaseUntil',
  liveExtractionLeaseToken: 'liveExtractionLeaseToken',
  liveExtractionLeaseUntil: 'liveExtractionLeaseUntil',
  extractionAttemptCount: 'extractionAttemptCount',
  extractionClaimedAt: 'extractionClaimedAt',
  graphWrittenAt: 'graphWrittenAt',
  graphWriteSkippedReason: 'graphWriteSkippedReason',
  graphWriteAttemptCount: 'graphWriteAttemptCount',
  graphWriteClaimedAt: 'graphWriteClaimedAt',
  importSource: 'importSource',
  importExternalId: 'importExternalId',
  importUrl: 'importUrl',
  importedAt: 'importedAt',
  importExternalEventId: 'importExternalEventId',
  importContentHash: 'importContentHash',
  importBodyHash: 'importBodyHash',
  splitFromRecordingId: 'splitFromRecordingId',
  removedAt: 'removedAt',
  removedById: 'removedById',
  consentConfirmedById: 'consentConfirmedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RecordingScalarFieldEnum = (typeof RecordingScalarFieldEnum)[keyof typeof RecordingScalarFieldEnum]


export const RecordingChunkScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  chunkIndex: 'chunkIndex',
  startedAtMs: 'startedAtMs',
  durationMs: 'durationMs',
  recovered: 'recovered',
  transcribedAt: 'transcribedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RecordingChunkScalarFieldEnum = (typeof RecordingChunkScalarFieldEnum)[keyof typeof RecordingChunkScalarFieldEnum]


export const LiveSummarySnapshotScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  version: 'version',
  throughMs: 'throughMs',
  topics: 'topics',
  createdAt: 'createdAt'
} as const

export type LiveSummarySnapshotScalarFieldEnum = (typeof LiveSummarySnapshotScalarFieldEnum)[keyof typeof LiveSummarySnapshotScalarFieldEnum]


export const LiveExtractionWindowScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  version: 'version',
  fromMs: 'fromMs',
  throughMs: 'throughMs',
  items: 'items',
  createdAt: 'createdAt'
} as const

export type LiveExtractionWindowScalarFieldEnum = (typeof LiveExtractionWindowScalarFieldEnum)[keyof typeof LiveExtractionWindowScalarFieldEnum]


export const NoteOutputFlagScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  recordingId: 'recordingId',
  targetKind: 'targetKind',
  targetRef: 'targetRef',
  targetText: 'targetText',
  spanIds: 'spanIds',
  reason: 'reason',
  comment: 'comment',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NoteOutputFlagScalarFieldEnum = (typeof NoteOutputFlagScalarFieldEnum)[keyof typeof NoteOutputFlagScalarFieldEnum]


export const NoteSummaryRevisionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  authorPersonId: 'authorPersonId',
  text: 'text',
  aiBaseline: 'aiBaseline',
  diff: 'diff',
  createdAt: 'createdAt'
} as const

export type NoteSummaryRevisionScalarFieldEnum = (typeof NoteSummaryRevisionScalarFieldEnum)[keyof typeof NoteSummaryRevisionScalarFieldEnum]


export const NoteThreadGistScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  threadKind: 'threadKind',
  threadKey: 'threadKey',
  newestNoteId: 'newestNoteId',
  memberCount: 'memberCount',
  memberDigest: 'memberDigest',
  memberIds: 'memberIds',
  gist: 'gist',
  promptKey: 'promptKey',
  model: 'model',
  generatedAt: 'generatedAt'
} as const

export type NoteThreadGistScalarFieldEnum = (typeof NoteThreadGistScalarFieldEnum)[keyof typeof NoteThreadGistScalarFieldEnum]


export const NoteSearchChunkScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  sourceKind: 'sourceKind',
  sourceId: 'sourceId',
  locator: 'locator',
  audienceParticipantId: 'audienceParticipantId',
  language: 'language',
  text: 'text',
  embeddingModel: 'embeddingModel',
  contentHash: 'contentHash',
  indexedAt: 'indexedAt'
} as const

export type NoteSearchChunkScalarFieldEnum = (typeof NoteSearchChunkScalarFieldEnum)[keyof typeof NoteSearchChunkScalarFieldEnum]


export const NoteSearchDirtyScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  reason: 'reason',
  enqueuedAt: 'enqueuedAt',
  claimedAt: 'claimedAt'
} as const

export type NoteSearchDirtyScalarFieldEnum = (typeof NoteSearchDirtyScalarFieldEnum)[keyof typeof NoteSearchDirtyScalarFieldEnum]


export const NoteShareScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  personId: 'personId',
  sharedById: 'sharedById',
  createdAt: 'createdAt'
} as const

export type NoteShareScalarFieldEnum = (typeof NoteShareScalarFieldEnum)[keyof typeof NoteShareScalarFieldEnum]


export const NoteSubjectScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  personId: 'personId',
  priorityId: 'priorityId',
  createdById: 'createdById',
  createdAt: 'createdAt'
} as const

export type NoteSubjectScalarFieldEnum = (typeof NoteSubjectScalarFieldEnum)[keyof typeof NoteSubjectScalarFieldEnum]


export const NoteRollupInputScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  rollupNoteId: 'rollupNoteId',
  inputNoteId: 'inputNoteId',
  addedById: 'addedById',
  createdAt: 'createdAt'
} as const

export type NoteRollupInputScalarFieldEnum = (typeof NoteRollupInputScalarFieldEnum)[keyof typeof NoteRollupInputScalarFieldEnum]


export const NoteChatSourceScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  noteId: 'noteId',
  pulseId: 'pulseId',
  createdAt: 'createdAt'
} as const

export type NoteChatSourceScalarFieldEnum = (typeof NoteChatSourceScalarFieldEnum)[keyof typeof NoteChatSourceScalarFieldEnum]


export const TranscriptSegmentScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  startMs: 'startMs',
  endMs: 'endMs',
  text: 'text',
  speakerLabel: 'speakerLabel',
  confidence: 'confidence',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TranscriptSegmentScalarFieldEnum = (typeof TranscriptSegmentScalarFieldEnum)[keyof typeof TranscriptSegmentScalarFieldEnum]


export const TranscriptVersionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  kind: 'kind',
  content: 'content',
  coherence: 'coherence',
  createdAt: 'createdAt',
  editedAt: 'editedAt',
  editedById: 'editedById',
  rerunRequestedAt: 'rerunRequestedAt'
} as const

export type TranscriptVersionScalarFieldEnum = (typeof TranscriptVersionScalarFieldEnum)[keyof typeof TranscriptVersionScalarFieldEnum]


export const TranscriptVersionWindowScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  windowIndex: 'windowIndex',
  fingerprint: 'fingerprint',
  coherence: 'coherence',
  readable: 'readable',
  createdAt: 'createdAt'
} as const

export type TranscriptVersionWindowScalarFieldEnum = (typeof TranscriptVersionWindowScalarFieldEnum)[keyof typeof TranscriptVersionWindowScalarFieldEnum]


export const ExtractedItemScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  kind: 'kind',
  quotedText: 'quotedText',
  ownerText: 'ownerText',
  dueText: 'dueText',
  commitmentLevel: 'commitmentLevel',
  corroboratingQuotes: 'corroboratingQuotes',
  aiDataCategory: 'aiDataCategory',
  aiSensitivityLevel: 'aiSensitivityLevel',
  aiClassificationRationale: 'aiClassificationRationale',
  priorityId: 'priorityId',
  state: 'state',
  taskId: 'taskId',
  dismissedReason: 'dismissedReason',
  startMs: 'startMs',
  endMs: 'endMs',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ExtractedItemScalarFieldEnum = (typeof ExtractedItemScalarFieldEnum)[keyof typeof ExtractedItemScalarFieldEnum]


export const TranscriptionJobScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  recordingId: 'recordingId',
  status: 'status',
  attemptCount: 'attemptCount',
  lastError: 'lastError',
  lastCommittedSegmentIndex: 'lastCommittedSegmentIndex',
  lastCommittedEndMs: 'lastCommittedEndMs',
  claimedAt: 'claimedAt',
  completedAt: 'completedAt',
  lateAudioRerunAt: 'lateAudioRerunAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TranscriptionJobScalarFieldEnum = (typeof TranscriptionJobScalarFieldEnum)[keyof typeof TranscriptionJobScalarFieldEnum]


export const OutputTemplateScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  name: 'name',
  description: 'description',
  scope: 'scope',
  ownerPersonId: 'ownerPersonId',
  sourceFileRef: 'sourceFileRef',
  sourceKind: 'sourceKind',
  sourceUrl: 'sourceUrl',
  sourceName: 'sourceName',
  fields: 'fields',
  version: 'version',
  copiedFromTemplateId: 'copiedFromTemplateId',
  copiedFromVersion: 'copiedFromVersion',
  heldBy: 'heldBy',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OutputTemplateScalarFieldEnum = (typeof OutputTemplateScalarFieldEnum)[keyof typeof OutputTemplateScalarFieldEnum]


export const OutputTemplateVersionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  templateId: 'templateId',
  version: 'version',
  name: 'name',
  fields: 'fields',
  firstUsedAt: 'firstUsedAt',
  createdById: 'createdById',
  createdAt: 'createdAt'
} as const

export type OutputTemplateVersionScalarFieldEnum = (typeof OutputTemplateVersionScalarFieldEnum)[keyof typeof OutputTemplateVersionScalarFieldEnum]


export const TemplateResponseScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  templateId: 'templateId',
  templateVersion: 'templateVersion',
  subjectPersonId: 'subjectPersonId',
  respondentPersonId: 'respondentPersonId',
  sourceKind: 'sourceKind',
  sourceId: 'sourceId',
  noteId: 'noteId',
  values: 'values',
  noteFilledContentHash: 'noteFilledContentHash',
  noteFillProposal: 'noteFillProposal',
  status: 'status',
  confirmedAt: 'confirmedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TemplateResponseScalarFieldEnum = (typeof TemplateResponseScalarFieldEnum)[keyof typeof TemplateResponseScalarFieldEnum]


export const OutputTemplateAttachmentScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  templateId: 'templateId',
  conversationKind: 'conversationKind',
  groupId: 'groupId',
  attachedById: 'attachedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OutputTemplateAttachmentScalarFieldEnum = (typeof OutputTemplateAttachmentScalarFieldEnum)[keyof typeof OutputTemplateAttachmentScalarFieldEnum]


export const OrgAiProfileScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  content: 'content',
  updatedByKind: 'updatedByKind',
  updatedById: 'updatedById',
  lastLearnedAt: 'lastLearnedAt',
  lastAttemptedAt: 'lastAttemptedAt',
  signalCursors: 'signalCursors',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OrgAiProfileScalarFieldEnum = (typeof OrgAiProfileScalarFieldEnum)[keyof typeof OrgAiProfileScalarFieldEnum]


export const OrgAiProfileRevisionScalarFieldEnum = {
  id: 'id',
  orgId: 'orgId',
  profileId: 'profileId',
  content: 'content',
  previousContent: 'previousContent',
  changeSummary: 'changeSummary',
  source: 'source',
  evidenceRefs: 'evidenceRefs',
  revertedRevisionId: 'revertedRevisionId',
  createdAt: 'createdAt',
  createdById: 'createdById'
} as const

export type OrgAiProfileRevisionScalarFieldEnum = (typeof OrgAiProfileRevisionScalarFieldEnum)[keyof typeof OrgAiProfileRevisionScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

